function ownKeys(e, t) {
    var a = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t && (o = o.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
        })), a.push.apply(a, o)
    }
    return a
}

function _objectSpread(e) {
    for (var t = 1; t < arguments.length; t++) {
        var a = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ownKeys(Object(a), !0).forEach(function (t) {
            _defineProperty(e, t, a[t])
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : ownKeys(Object(a)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t))
        })
    }
    return e
}

function _defineProperty(e, t, a) {
    return t in e ? Object.defineProperty(e, t, {
        value: a,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = a, e
}! function (e) {
    var t, a, o, n, s, e = jQuery = e,
        r = {
            sections: []
        };
    theme.Shopify = {
        formatMoney: function e(t, a) {
            function o(e, t) {
                return void 0 === e ? t : e
            }

            function n(e, t, a, n) {
                if (t = o(t, 2), a = o(a, ","), n = o(n, "."), isNaN(e) || null == e) return 0;
                var s = (e = (e / 100).toFixed(t)).split(".");
                return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (s[1] ? n + s[1] : "")
            }
            "string" == typeof t && (t = t.replace(".", ""));
            var s = "",
                r = /\{\{\s*(\w+)\s*\}\}/,
                l = a || this.money_format;
            switch (l.match(r)[1]) {
                case "amount":
                    s = n(t, 2);
                    break;
                case "amount_no_decimals":
                    s = n(t, 0);
                    break;
                case "amount_with_comma_separator":
                    s = n(t, 2, ".", ",");
                    break;
                case "amount_with_space_separator":
                    s = n(t, 2, " ", ",");
                    break;
                case "amount_with_period_and_space_separator":
                    s = n(t, 2, " ", ".");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    s = n(t, 0, ".", ",");
                    break;
                case "amount_no_decimals_with_space_separator":
                    s = n(t, 0, " ", "");
                    break;
                case "amount_with_apostrophe_separator":
                    s = n(t, 2, "'", ".");
                    break;
                case "amount_with_decimal_separator":
                    s = n(t, 2, ".", ".")
            }
            return l.replace(r, s)
        },
        formatImage: function e(t, a) {
            return t ? t.replace(/^(.*)\.([^\.]*)$/g, "$1_" + a + ".$2") : ""
        },
        Image: {
            imageSize: function e(t) {
                var a = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                return null !== a ? a[1] : null
            },
            getSizedImageUrl: function e(t, a) {
                if (null == a) return t;
                if ("master" == a) return this.removeProtocol(t);
                var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                if (null != o) {
                    var n = t.split(o[0]),
                        s = o[0];
                    return this.removeProtocol(n[0] + "_" + a + s)
                }
                return null
            },
            removeProtocol: function e(t) {
                return t.replace(/http(s)?:/, "")
            }
        }
    };
    class l {
        constructor(t) {
            var a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(t),
                o = this;
            this.instances = [], e(document).on("cc:component:load", function (n, s, r) {
                s === t && e(r).find("".concat(a, ":not(.cc-initialized)")).each(function () {
                    o.init(this)
                })
            }), e(document).on("cc:component:unload", function (n, s, r) {
                s === t && e(r).find(a).each(function () {
                    o.destroy(this)
                })
            }), e(a).each(function () {
                o.init(this)
            })
        }
        init(t) {
            e(t).addClass("cc-initialized")
        }
        destroy(t) {
            e(t).removeClass("cc-initialized")
        }
        registerInstance(e, t) {
            this.instances.push({
                container: e,
                instance: t
            })
        }
        destroyInstance(e) {
            this.instances = this.instances.filter(t => {
                if (t.container === e) return "function" == typeof t.instance.destroy && t.instance.destroy(), t.container !== e
            })
        }
    }
    theme.Sections = new function () {
        var t = this;
        t._instances = [], t._deferredSectionTargets = [], t._sections = [], t._deferredLoadViewportExcess = 300, t._deferredWatcherRunning = !1, t.init = function () {
            e(document).on("shopify:section:load", function (e) {
                var a = t._themeSectionTargetFromShopifySectionTarget(e.target);
                a && t.sectionLoad(a)
            }).on("shopify:section:unload", function (e) {
                var a = t._themeSectionTargetFromShopifySectionTarget(e.target);
                a && t.sectionUnload(a)
            }).on("shopify:section:reorder", function (e) {
                var a = t._themeSectionTargetFromShopifySectionTarget(e.target);
                a && t.sectionReorder(a)
            }), e(window).on("throttled-scroll.themeSectionDeferredLoader debouncedresize.themeSectionDeferredLoader", t._processDeferredSections), t._deferredWatcherRunning = !0
        }, t.register = function (a, o, n) {
            t._sections.push({
                type: a,
                section: o,
                afterSectionLoadCallback: n ? n.afterLoad : null,
                afterSectionUnloadCallback: n ? n.afterUnload : null
            }), e('[data-section-type="' + a + '"]').each(function () {
                Shopify.designMode || n && !1 === n.deferredLoad || !t._deferredWatcherRunning ? t.sectionLoad(this) : t.sectionDeferredLoad(this, n)
            })
        }, t.sectionDeferredLoad = function (e, a) {
            t._deferredSectionTargets.push({
                target: e,
                deferredLoadViewportExcess: a && a.deferredLoadViewportExcess ? a.deferredLoadViewportExcess : t._deferredLoadViewportExcess
            }), t._processDeferredSections(!0)
        }, t._processDeferredSections = function (a) {
            if (t._deferredSectionTargets.length)
                for (var o = e(window).scrollTop(), n = o + e(window).height(), s = !0 === a ? t._deferredSectionTargets.length - 1 : 0, r = s; r < t._deferredSectionTargets.length; r++) {
                    var l = t._deferredSectionTargets[r].target,
                        c = t._deferredSectionTargets[r].deferredLoadViewportExcess,
                        d = e(l).offset().top - c,
                        h = d > o && d < n;
                    if (!h) {
                        var u = d + e(l).outerHeight() + 2 * c;
                        h = u > o && u < n
                    }(h || d < o && u > n) && (t.sectionLoad(l), t._deferredSectionTargets.splice(r, 1), r--)
                }!0 !== a && 0 === t._deferredSectionTargets.length && (t._deferredWatcherRunning = !1, e(window).off(".themeSectionDeferredLoader"))
        }, t.sectionLoad = function (a) {
            var a = a,
                o = t._sectionForTarget(a),
                n = !1;
            if (!1 !== (n = o.section ? o.section : o)) {
                var s = {
                    target: a,
                    section: n,
                    $shopifySectionContainer: e(a).closest(".shopify-section"),
                    thisContext: {
                        functions: n.functions,
                        registeredEventListeners: []
                    }
                };
                s.thisContext.registerEventListener = t._registerEventListener.bind(s.thisContext), t._instances.push(s), e(a).data("components") && e(a).data("components").split(",").forEach(t => {
                    e(document).trigger("cc:component:load", [t, a])
                }), t._callSectionWith(n, "onSectionLoad", a, s.thisContext), t._callSectionWith(n, "afterSectionLoadCallback", a, s.thisContext), n.onSectionSelect && s.$shopifySectionContainer.on("shopify:section:select", function (e) {
                    t._callSectionWith(n, "onSectionSelect", e.target, s.thisContext)
                }), n.onSectionDeselect && s.$shopifySectionContainer.on("shopify:section:deselect", function (e) {
                    t._callSectionWith(n, "onSectionDeselect", e.target, s.thisContext)
                }), n.onBlockSelect && e(a).on("shopify:block:select", function (e) {
                    t._callSectionWith(n, "onBlockSelect", e.target, s.thisContext)
                }), n.onBlockDeselect && e(a).on("shopify:block:deselect", function (e) {
                    t._callSectionWith(n, "onBlockDeselect", e.target, s.thisContext)
                })
            }
        }, t.sectionUnload = function (a) {
            for (var o = t._sectionForTarget(a), n = -1, s = 0; s < t._instances.length; s++) t._instances[s].target == a && (n = s);
            if (n > -1) {
                var r = t._instances[n];
                e(a).off("shopify:block:select shopify:block:deselect"), r.$shopifySectionContainer.off("shopify:section:select shopify:section:deselect"), t._callSectionWith(r.section, "onSectionUnload", a, r.thisContext), t._unloadRegisteredEventListeners(r.thisContext.registeredEventListeners), t._callSectionWith(o, "afterSectionUnloadCallback", a, r.thisContext), t._instances.splice(n), e(a).data("components") && e(a).data("components").split(",").forEach(t => {
                    e(document).trigger("cc:component:unload", [t, a])
                })
            } else
                for (var s = 0; s < t._deferredSectionTargets.length; s++)
                    if (t._deferredSectionTargets[s].target == a) {
                        t._deferredSectionTargets[s].splice(s, 1);
                        break
                    }
        }, t.sectionReorder = function (e) {
            for (var a = -1, o = 0; o < t._instances.length; o++) t._instances[o].target == e && (a = o);
            if (a > -1) {
                var n = t._instances[a];
                t._callSectionWith(n.section, "onSectionReorder", e, n.thisContext)
            }
        }, t._registerEventListener = function (e, t, a) {
            e.addEventListener(t, a), this.registeredEventListeners.push({
                element: e,
                eventType: t,
                callback: a
            })
        }, t._unloadRegisteredEventListeners = function (e) {
            e.forEach(e => {
                e.element.removeEventListener(e.eventType, e.callback)
            })
        }, t._callSectionWith = function (e, t, a, o) {
            if ("function" == typeof e[t]) try {
                o ? e[t].bind(o)(a) : e[t](a)
            } catch (n) {
                var s = a.dataset.sectionType;
                console.warn("Theme warning: '".concat(t, "' failed for section '").concat(s, "'")), console.debug(a, n)
            }
        }, t._themeSectionTargetFromShopifySectionTarget = function (t) {
            var a = e("[data-section-type]:first", t);
            return a.length > 0 && a[0]
        }, t._sectionForTarget = function (a) {
            for (var o = e(a).attr("data-section-type"), n = 0; n < t._sections.length; n++)
                if (t._sections[n].type == o) return t._sections[n];
            return !1
        }, t._sectionAlreadyRegistered = function (e) {
            for (var a = 0; a < t._sections.length; a++)
                if (t._sections[a].type == e) return !0;
            return !1
        }
    }, theme.scriptsLoaded = {}, theme.loadScriptOnce = function (e, t, a, o) {
        if (void 0 === theme.scriptsLoaded[e]) {
            theme.scriptsLoaded[e] = [];
            var n = document.createElement("script");
            n.src = e, (o || a) && (n.async = !1), a && a(), "function" == typeof t && (theme.scriptsLoaded[e].push(t), n.readyState ? n.onreadystatechange = (function () {
                if ("loaded" == n.readyState || "complete" == n.readyState) {
                    n.onreadystatechange = null;
                    for (var e = 0; e < theme.scriptsLoaded[this].length; e++) theme.scriptsLoaded[this][e]();
                    theme.scriptsLoaded[this] = !0
                }
            }).bind(e) : n.onload = (function () {
                for (var e = 0; e < theme.scriptsLoaded[this].length; e++) theme.scriptsLoaded[this][e]();
                theme.scriptsLoaded[this] = !0
            }).bind(e));
            var s = document.getElementsByTagName("script")[0];
            return s.parentNode.insertBefore(n, s), !0
        }
        if ("object" != typeof theme.scriptsLoaded[e] || "function" != typeof t) return "function" == typeof t && t(), !1;
        theme.scriptsLoaded[e].push(t)
    }, theme.loadStyleOnce = function (e) {
        var t = e.replace(/^https?:/, "");
        if (!document.querySelector('link[href="' + encodeURI(t) + '"]')) {
            var a = document.createElement("link");
            a.href = t, a.rel = "stylesheet", a.type = "text/css";
            var o = document.getElementsByTagName("link")[0];
            o.parentNode.insertBefore(a, o)
        }
    }, theme.Disclosure = function () {
        var t = {
                disclosureList: "[data-disclosure-list]",
                disclosureToggle: "[data-disclosure-toggle]",
                disclosureInput: "[data-disclosure-input]",
                disclosureOptions: "[data-disclosure-option]"
            },
            a = {
                listVisible: "disclosure-list--visible"
            };

        function o(e) {
            this.$container = e, this.cache = {}, this._cacheSelectors(), this._connectOptions(), this._connectToggle(), this._onFocusOut()
        }
        return o.prototype = e.extend({}, o.prototype, {
            _cacheSelectors: function e() {
                this.cache = {
                    $disclosureList: this.$container.find(t.disclosureList),
                    $disclosureToggle: this.$container.find(t.disclosureToggle),
                    $disclosureInput: this.$container.find(t.disclosureInput),
                    $disclosureOptions: this.$container.find(t.disclosureOptions)
                }
            },
            _connectToggle: function t() {
                this.cache.$disclosureToggle.on("click", (function (t) {
                    var o = "true" === e(t.currentTarget).attr("aria-expanded");
                    e(t.currentTarget).attr("aria-expanded", !o), this.cache.$disclosureList.toggleClass(a.listVisible)
                }).bind(this))
            },
            _connectOptions: function t() {
                this.cache.$disclosureOptions.on("click", (function (t) {
                    t.preventDefault(), this._submitForm(e(t.currentTarget).data("value"))
                }).bind(this))
            },
            _onFocusOut: function t() {
                this.cache.$disclosureToggle.on("focusout", (function (e) {
                    0 === this.$container.has(e.relatedTarget).length && this._hideList()
                }).bind(this)), this.cache.$disclosureList.on("focusout", (function (t) {
                    var o = e(t.currentTarget).has(t.relatedTarget).length > 0;
                    this.cache.$disclosureList.hasClass(a.listVisible) && !o && this._hideList()
                }).bind(this)), this.$container.on("keyup", (function (e) {
                    27 === e.which && (this._hideList(), this.cache.$disclosureToggle.focus())
                }).bind(this)), this.bodyOnClick = (function (e) {
                    var t = this.$container.has(e.target).length > 0;
                    this.cache.$disclosureList.hasClass(a.listVisible) && !t && this._hideList()
                }).bind(this), e("body").on("click", this.bodyOnClick)
            },
            _submitForm: function e(t) {
                this.cache.$disclosureInput.val(t), this.$container.parents("form").submit()
            },
            _hideList: function e() {
                this.cache.$disclosureList.removeClass(a.listVisible), this.cache.$disclosureToggle.attr("aria-expanded", !1)
            },
            unload: function t() {
                e("body").off("click", this.bodyOnClick), this.cache.$disclosureOptions.off(), this.cache.$disclosureToggle.off(), this.cache.$disclosureList.off(), this.$container.off()
            }
        }), o
    }(), theme.showQuickPopup = function (t, a) {
        var o = e('<div class="simple-popup"/>'),
            n = a.offset();
        o.html(t).css({
            left: n.left,
            top: n.top
        }).hide(), e("body").append(o), o.css({
            marginTop: -o.outerHeight() - 10,
            marginLeft: -(o.outerWidth() - a.outerWidth()) / 2
        }), o.fadeIn(200).delay(3500).fadeOut(400, function () {
            e(this).remove()
        })
    }, e.fn.sort = [].sort, e.fn.fadeOutAndRemove = function (t, a) {
        e(this).fadeOut(t, function () {
            e(this).remove(), "function" == typeof a && a()
        })
    }, e.fn.clickyBoxes = function (t) {
        if ("destroy" != t) return e(this).filter("select:not(.clickybox-replaced)").addClass("clickybox-replaced").each(function () {
            var t, a = a || e(this).attr("id"),
                o = e('<ul class="clickyboxes"/>').attr("id", "clickyboxes-" + a).data("select", e(this)).insertAfter(this);
            (t = e(this).is("[id]") ? e('label[for="' + e(this).attr("id") + '"]') : e(this).siblings("label")).length > 0 && o.addClass("options-" + removeDiacritics(t.text()).toLowerCase().replace(/'/g, "").replace(/[^a-z0-9]+/g, "-").replace(/-+/g, "-").replace(/-*$/, "")), e(this).find("option").each(function () {
                e("<li/>").appendTo(o).append(e('<a href="#"/>').attr("data-value", e(this).val()).html(e(this).html()).addClass("opt--" + removeDiacritics(e(this).text()).toLowerCase().replace(/'/g, "").replace(/[^a-z0-9]+/g, "-").replace(/-+/g, "-").replace(/-*$/, "")))
            }), e(this).hide().addClass("replaced").on("change.clickyboxes keyup.clickyboxes", function () {
                var t = e(this).val();
                o.find("a").removeClass("active").filter(function () {
                    return e(this).attr("data-value") == t
                }).addClass("active")
            }).trigger("keyup"), o.on("click.clickyboxes", "a", function () {
                if (!e(this).hasClass("active")) {
                    var t = e(this).closest(".clickyboxes");
                    t.data("select").val(e(this).data("value")).trigger("change"), t.trigger("change")
                }
                return !1
            })
        });
        e(this).off(".clickyboxes"), e(this).next(".clickyboxes").off(".clickyboxes")
    }, e.scrollBarWidth = function () {
        var t = e("<div/>").css({
                width: 100,
                height: 100,
                overflow: "scroll",
                position: "absolute",
                top: -9999
            }).prependTo("body"),
            a = t[0].offsetWidth - t[0].clientWidth;
        return t.remove(), a
    }, e.fn.selectReplace = function (t) {
        return e(this).filter("select:not(.replaced, .noreplace)").each(function () {
            var a = e(this).find("option"),
                o = a.filter(":selected").length > 0 ? a.filter(":selected").text() : a.first().text(),
                n = e(this).addClass("replaced").wrap('<div class="pretty-select">').parent().addClass("id-" + e(this).attr("id")).append('<span class="text"><span class="value">' + o + '</span></span><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>');
            if (e(this).attr("id")) {
                var s = e('label[for="' + e(this).attr("id") + '"]'),
                    r = e(this).closest("td"),
                    l = s.closest("td");
                if (!t && (0 == r.length || 0 == l.length || r[0] == l[0])) {
                    var c = e('<span class="label">').html(s.html()).prependTo(n.find(".text"));
                    ":" != c.slice(-1) && c.append(":"), n.find("select").attr("aria-label", s.text()), s.remove()
                }
            }
        }).on("change keyup", function () {
            e(this).siblings(".text").find(".value").html(e(this).find(":selected").html())
        })
    }, e.fn.ccHoverLine = function (t) {
        e(this).each(function () {
            var a = e(this);
            if (!a.hasClass("cc-init")) {
                a.append("<li class='cc-hover-line'></li>").addClass("cc-init");
                var o = e(this).find(".cc-hover-line");

                function n() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.find('li a[aria-selected="true"], li a.active');
                    1 === e.length && o.css({
                        width: e.width(),
                        top: e.position().top + e.outerHeight(),
                        left: e.position().left
                    })
                }
                t && t.lineCss && o.css(t.lineCss), n(), 768 > e(window).outerWidth() ? e(this).find("li").click(function () {
                    var t = e(this).find("a");
                    1 === t.length && n(t)
                }) : e(this).find("li").hover(function () {
                    var t = e(this).find("a");
                    1 === t.length && n(t)
                }, function () {
                    n()
                }), e(window).on("debouncedresizewidth", function () {
                    n()
                })
            }
        })
    }, (t = document.createEvent("Event")).initEvent("throttled-scroll", !0, !0), o = 200, window.addEventListener("scroll", (a = function () {
        window.dispatchEvent(t)
    }, n = -1, s = !1, function () {
        clearTimeout(n), n = setTimeout(a, o), s || (a.call(), s = !0, setTimeout(function () {
            s = !1
        }, o))
    })), theme.cartNoteMonitor = {
        load: function t(a) {
            a.on("change.themeCartNoteMonitor paste.themeCartNoteMonitor keyup.themeCartNoteMonitor", function () {
                theme.cartNoteMonitor.postUpdate(e(this).val())
            })
        },
        unload: function e(t) {
            t.off(".themeCartNoteMonitor")
        },
        updateThrottleTimeoutId: -1,
        updateThrottleInterval: 500,
        postUpdate: function t(a) {
            clearTimeout(theme.cartNoteMonitor.updateThrottleTimeoutId), theme.cartNoteMonitor.updateThrottleTimeoutId = setTimeout(function () {
                e.post(theme.routes.cart_url + "/update.js", {
                    note: a
                }, function (e) {}, "json")
            }, theme.cartNoteMonitor.updateThrottleInterval)
        }
    }, theme.debounce = function (e) {
        var t, a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 700,
            o = arguments.length > 2 ? arguments[2] : void 0;
        return function () {
            var n = this,
                s = arguments,
                r = function a() {
                    t = null, o || e.apply(n, s)
                },
                l = o && !t;
            clearTimeout(t), t = setTimeout(r, a), l && e.apply(n, s)
        }
    }, new class extends l {
        init(t) {
            super.init(t);
            var a = e(t);

            function o() {
                var e = new CustomEvent("cc-tab-changed");
                window.dispatchEvent(e)
            }
            a.on("click", "[data-cc-toggle-panel]", function () {
                var t = e(this).closest(".cc-tabs"),
                    a = e(this).data("cc-toggle-panel"),
                    n = t.find(".cc-tabs__tab__panel:visible"),
                    s = t.find('.cc-tabs__tab .cc-tabs__tab__panel[aria-labelledby="product-tab-panel'.concat(a, '"]')),
                    r = e(this).closest('.cc-tabs[data-cc-tab-allow-multi-open="true"]').length;
                if (t.hasClass("cc-tabs--tab-mode")) n.attr("hidden", ""), s.removeAttr("hidden"), t.find('[role="tab"] [aria-selected="true"]').removeAttr("aria-selected"), t.find('[data-cc-toggle-panel="'.concat(a, '"]')).attr("aria-selected", "true");
                else {
                    if (r) {
                        if (s.is(":visible")) {
                            var l = !0,
                                c = !1;
                            n = s
                        } else var l = !1,
                            c = !0
                    } else var l = n.length,
                        c = s.attr("id") !== n.attr("id") && s.length;
                    768 > e(window).outerWidth() && (s.is(":visible") ? (l = !0, c = !1, n = s) : l = !1), l && (n.slideUp(300, function () {
                        e(this).attr("hidden", ""), c || o()
                    }), n.prev().removeAttr("aria-selected")), c && (s.css("display", "none").removeAttr("hidden").slideDown(300, o), s.prev().attr("aria-selected", "true"))
                }
                return !1
            }), a.hasClass("cc-tabs--tab-mode") && a.find(".cc-tabs__tab-headers").ccHoverLine()
        }
        destroy(t) {
            super.destroy(t), e(t).off("click", "[data-cc-toggle-panel]")
        }
    }("tabs"), (() => {
        theme.initAnimateOnScroll = function () {
            if (document.body.classList.contains("cc-animate-enabled") && window.innerWidth >= 768) {
                var e = void 0 !== document.body.dataset.ccAnimateTimeout ? document.body.dataset.ccAnimateTimeout : 200;
                if ("IntersectionObserver" in window) {
                    var t = new IntersectionObserver((t, a) => {
                        t.forEach(t => {
                            t.isIntersecting && !t.target.classList.contains("cc-animate-complete") && (setTimeout(() => {
                                t.target.classList.add("-in", "cc-animate-complete")
                            }, e), setTimeout(() => {
                                t.target.classList.remove("data-cc-animate"), t.target.style.transitionDuration = null, t.target.style.transitionDelay = null
                            }, 5e3), a.unobserve(t.target))
                        })
                    });
                    document.querySelectorAll("[data-cc-animate]:not(.cc-animate-init)").forEach(e => {
                        e.dataset.ccAnimateDelay && (e.style.transitionDelay = e.dataset.ccAnimateDelay), e.dataset.ccAnimateDuration && (e.style.transitionDuration = e.dataset.ccAnimateDuration), e.dataset.ccAnimate && e.classList.add(e.dataset.ccAnimate), e.classList.add("cc-animate-init"), t.observe(e)
                    })
                } else
                    for (var a = document.querySelectorAll("[data-cc-animate]:not(.cc-animate-init)"), o = 0; o < a.length; o++) a[o].classList.add("-in", "cc-animate-complete")
            }
        }, theme.initAnimateOnScroll(), document.addEventListener("shopify:section:load", () => {
            setTimeout(theme.initAnimateOnScroll, 100)
        });
        try {
            window.matchMedia("(min-width: 768px)").addEventListener("change", e => {
                e.matches && setTimeout(theme.initAnimateOnScroll, 100)
            })
        } catch (e) {}
    })();
    class c {
        constructor(e, t) {
            this.$container = e, this.namespace = t, this.cssClasses = {
                visible: "cc-popup--visible",
                bodyNoScroll: "cc-popup-no-scroll",
                bodyNoScrollPadRight: "cc-popup-no-scroll-pad-right"
            }
        }
        open(t) {
            if (this.$container.data("freeze-scroll")) {
                clearTimeout(theme.ccPopupRemoveScrollFreezeTimeoutId), e("body").addClass(this.cssClasses.bodyNoScroll);
                var a = document.createElement("div");
                a.className = "popup-scrollbar-measure", document.body.appendChild(a);
                var o = a.getBoundingClientRect().width - a.clientWidth;
                document.body.removeChild(a), o > 0 && e("body").css("padding-right", o + "px").addClass(this.cssClasses.bodyNoScrollPadRight)
            }
            this.$container.addClass(this.cssClasses.visible), this.previouslyActiveElement = document.activeElement, setTimeout(() => {
                this.$container.find(".cc-popup-close")[0].focus()
            }, 500), e(window).on("keydown" + this.namespace, e => {
                27 === e.keyCode && this.close()
            }), t && t()
        }
        close(t) {
            if (this.$container.removeClass(this.cssClasses.visible), this.previouslyActiveElement && e(this.previouslyActiveElement).focus(), e(window).off("keydown" + this.namespace), 0 === e("." + this.cssClasses.visible).filter(() => this.$container.data("freeze-scroll")).length) {
                var a = 500,
                    o = this.$container.find(".cc-popup-modal");
                o.length && (a = parseFloat(getComputedStyle(o[0]).transitionDuration)) && a > 0 && (a *= 1e3), theme.ccPopupRemoveScrollFreezeTimeoutId = setTimeout(() => {
                    e("body").removeClass(this.cssClasses.bodyNoScroll).removeClass(this.cssClasses.bodyNoScrollPadRight).css("padding-right", "0")
                }, a)
            }
            t && t()
        }
    }
    class d {
        constructor(e) {
            this.container = e, this.selectors = {
                inputMin: ".cc-price-range__input--min",
                inputMax: ".cc-price-range__input--max",
                control: ".cc-price-range__control",
                controlMin: ".cc-price-range__control--min",
                controlMax: ".cc-price-range__control--max",
                bar: ".cc-price-range__bar",
                activeBar: ".cc-price-range__bar-active"
            }, this.controls = {
                min: {
                    barControl: e.querySelector(this.selectors.controlMin),
                    input: e.querySelector(this.selectors.inputMin)
                },
                max: {
                    barControl: e.querySelector(this.selectors.controlMax),
                    input: e.querySelector(this.selectors.inputMax)
                }
            }, this.controls.min.value = parseInt("" === this.controls.min.input.value ? this.controls.min.input.placeholder : this.controls.min.input.value), this.controls.max.value = parseInt("" === this.controls.max.input.value ? this.controls.max.input.placeholder : this.controls.max.input.value), this.valueMin = this.controls.min.input.min, this.valueMax = this.controls.min.input.max, this.valueRange = this.valueMax - this.valueMin, [this.controls.min, this.controls.max].forEach(e => {
                e.barControl.setAttribute("aria-valuemin", this.valueMin), e.barControl.setAttribute("aria-valuemax", this.valueMax), e.barControl.setAttribute("tabindex", 0)
            }), this.controls.min.barControl.setAttribute("aria-valuenow", this.controls.min.value), this.controls.max.barControl.setAttribute("aria-valuenow", this.controls.max.value), this.bar = e.querySelector(this.selectors.bar), this.activeBar = e.querySelector(this.selectors.activeBar), this.inDrag = !1, this.rtl = document.querySelector("html[dir=rtl]"), this.bindEvents(), this.render()
        }
        getPxToValueRatio() {
            var e = this.bar.clientWidth / (this.valueMax - this.valueMin);
            return this.rtl ? -e : e
        }
        getPcToValueRatio() {
            return 100 / (this.valueMax - this.valueMin)
        }
        setActiveControlValue(e) {
            isNaN(parseInt(e)) || (this.activeControl === this.controls.min ? ("" === e && (e = this.valueMin), e = Math.min(e = Math.max(this.valueMin, e), this.controls.max.value)) : ("" === e && (e = this.valueMax), e = Math.max(e = Math.min(this.valueMax, e), this.controls.min.value)), this.activeControl.value = Math.round(e), this.activeControl.input.value != this.activeControl.value && (this.activeControl.value == this.activeControl.input.placeholder ? this.activeControl.input.value = "" : this.activeControl.input.value = this.activeControl.value, this.activeControl.input.dispatchEvent(new CustomEvent("change", {
                bubbles: !0,
                cancelable: !1,
                detail: {
                    sender: "theme:component:price_range"
                }
            }))), this.activeControl.barControl.setAttribute("aria-valuenow", this.activeControl.value))
        }
        render() {
            this.drawControl(this.controls.min), this.drawControl(this.controls.max), this.drawActiveBar()
        }
        drawControl(e) {
            var t = (e.value - this.valueMin) * this.getPcToValueRatio() + "%";
            this.rtl ? e.barControl.style.right = t : e.barControl.style.left = t
        }
        drawActiveBar() {
            var e = (this.controls.min.value - this.valueMin) * this.getPcToValueRatio() + "%",
                t = (this.valueMax - this.controls.max.value) * this.getPcToValueRatio() + "%";
            this.rtl ? (this.activeBar.style.left = t, this.activeBar.style.right = e) : (this.activeBar.style.left = e, this.activeBar.style.right = t)
        }
        handleControlTouchStart(e) {
            e.preventDefault(), this.startDrag(e.target, e.touches[0].clientX), this.boundControlTouchMoveEvent = this.handleControlTouchMove.bind(this), this.boundControlTouchEndEvent = this.handleControlTouchEnd.bind(this), window.addEventListener("touchmove", this.boundControlTouchMoveEvent), window.addEventListener("touchend", this.boundControlTouchEndEvent)
        }
        handleControlTouchMove(e) {
            this.moveDrag(e.touches[0].clientX)
        }
        handleControlTouchEnd(e) {
            e.preventDefault(), window.removeEventListener("touchmove", this.boundControlTouchMoveEvent), window.removeEventListener("touchend", this.boundControlTouchEndEvent), this.stopDrag()
        }
        handleControlMouseDown(e) {
            e.preventDefault(), this.startDrag(e.target, e.clientX), this.boundControlMouseMoveEvent = this.handleControlMouseMove.bind(this), this.boundControlMouseUpEvent = this.handleControlMouseUp.bind(this), window.addEventListener("mousemove", this.boundControlMouseMoveEvent), window.addEventListener("mouseup", this.boundControlMouseUpEvent)
        }
        handleControlMouseMove(e) {
            this.moveDrag(e.clientX)
        }
        handleControlMouseUp(e) {
            e.preventDefault(), window.removeEventListener("mousemove", this.boundControlMouseMoveEvent), window.removeEventListener("mouseup", this.boundControlMouseUpEvent), this.stopDrag()
        }
        startDrag(e, t) {
            this.controls.min.barControl === e ? this.activeControl = this.controls.min : this.activeControl = this.controls.max, this.dragStartX = t, this.dragStartValue = this.activeControl.value, this.inDrag = !0
        }
        moveDrag(e) {
            if (this.inDrag) {
                var t = this.dragStartValue + (e - this.dragStartX) / this.getPxToValueRatio();
                this.setActiveControlValue(t), this.render()
            }
        }
        stopDrag() {
            this.inDrag = !1
        }
        handleControlKeyDown(e) {
            "ArrowRight" === e.key ? this.incrementControlFromKeypress(e.target, 10) : "ArrowLeft" === e.key && this.incrementControlFromKeypress(e.target, -10)
        }
        incrementControlFromKeypress(e, t) {
            this.controls.min.barControl === e ? this.activeControl = this.controls.min : this.activeControl = this.controls.max, this.setActiveControlValue(this.activeControl.value + t / this.getPxToValueRatio()), this.render()
        }
        handleInputChange(e) {
            e.target.value = e.target.value.replace(/\D/g, ""), e.detail && "theme:component:price_range" == e.detail.sender || (this.controls.min.input === e.target ? this.activeControl = this.controls.min : this.activeControl = this.controls.max, this.setActiveControlValue(e.target.value), this.render())
        }
        handleInputKeyup(e) {
            setTimeout((function () {
                this.value = this.value.replace(/\D/g, "")
            }).bind(e.target), 10)
        }
        bindEvents() {
            [this.controls.min, this.controls.max].forEach(e => {
                e.barControl.addEventListener("touchstart", this.handleControlTouchStart.bind(this)), e.barControl.addEventListener("mousedown", this.handleControlMouseDown.bind(this)), e.barControl.addEventListener("keydown", this.handleControlKeyDown.bind(this)), e.input.addEventListener("change", this.handleInputChange.bind(this)), e.input.addEventListener("keyup", this.handleInputKeyup.bind(this))
            })
        }
        destroy() {}
    }
    new class e extends l {
        constructor() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "price-range",
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(e);
            super(e, t)
        }
        init(e) {
            super.init(e), this.registerInstance(e, new d(e))
        }
        destroy(e) {
            this.destroyInstance(e), super.destroy(e)
        }
    };
    class h {
        constructor(e) {
            this.accordion = e, this.itemClass = ".cc-accordion-item", this.titleClass = ".cc-accordion-item__title", this.panelClass = ".cc-accordion-item__panel", this.allowMultiOpen = "true" === this.accordion.dataset.allowMultiOpen, this.allowMultiOpen || (this.activeItem = this.accordion.querySelector("".concat(this.itemClass, "[open]"))), this.bindEvents()
        }
        static addPanelHeight(e) {
            e.style.height = "".concat(e.scrollHeight, "px")
        }
        static removePanelHeight(e) {
            e.getAttribute("style"), e.removeAttribute("style")
        }
        open(e, t) {
            if (t.style.height = "0", e.open = !0, h.addPanelHeight(t), setTimeout(() => {
                    e.classList.add("is-open")
                }, 10), !this.allowMultiOpen) {
                if (this.activeItem && this.activeItem !== e) {
                    var a = this.activeItem.querySelector(this.panelClass);
                    this.close(this.activeItem, a)
                }
                this.activeItem = e
            }
        }
        close(e, t) {
            h.addPanelHeight(t), e.classList.remove("is-open"), e.classList.add("is-closing"), this.activeItem === e && (this.activeItem = null), setTimeout(() => {
                t.style.height = "0"
            }, 10)
        }
        handleClick(e) {
            var t = e.target.closest(this.titleClass);
            if (t) {
                e.preventDefault();
                var a = t.parentNode,
                    o = t.nextElementSibling;
                a.open ? this.close(a, o) : this.open(a, o)
            }
        }
        handleTransition(e) {
            if (e.target.matches(this.panelClass)) {
                var t = e.target,
                    a = t.parentNode;
                a.classList.contains("is-closing") && (a.classList.remove("is-closing"), a.open = !1), h.removePanelHeight(t)
            }
        }
        bindEvents() {
            this.clickHandler = this.handleClick.bind(this), this.transitionHandler = this.handleTransition.bind(this), this.accordion.addEventListener("click", this.clickHandler), this.accordion.addEventListener("transitionend", this.transitionHandler)
        }
        destroy() {
            this.accordion.removeEventListener("click", this.clickHandler), this.accordion.removeEventListener("transitionend", this.transitionHandler)
        }
    }
    new class e extends l {
        constructor() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "accordion",
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(e);
            super(e, t)
        }
        init(e) {
            super.init(e), this.registerInstance(e, new h(e))
        }
        destroy(e) {
            this.destroyInstance(e), super.destroy(e)
        }
    };
    class u {
        constructor(e) {
            if (!e) {
                console.warn("StickyScrollDirection component: No container provided");
                return
            }
            window.innerWidth >= 768 && (this.container = e, this.currentTop = parseInt(getComputedStyle(this.container).top), this.defaultTop = this.currentTop, this.scrollY = window.scrollY, this.bindEvents())
        }
        bindEvents() {
            this.scrollListener = this.handleScroll.bind(this), window.addEventListener("scroll", this.scrollListener), void 0 !== this.container.dataset.ccStickyScrollTop && (this.observer = new MutationObserver(e => {
                for (var t of e) "data-cc-sticky-scroll-top" === t.attributeName && (this.defaultTop = parseInt(t.target.dataset.ccStickyScrollTop))
            }), this.observer.observe(this.container, {
                attributes: !0
            }))
        }
        handleScroll() {
            var e = this.container.getBoundingClientRect().top + window.scrollY - this.container.offsetTop + this.defaultTop,
                t = this.container.clientHeight - window.innerHeight;
            window.scrollY < this.scrollY ? this.currentTop -= window.scrollY - this.scrollY : this.currentTop += this.scrollY - window.scrollY, this.currentTop = Math.min(Math.max(this.currentTop, -t), e, this.defaultTop), this.scrollY = window.scrollY, this.container.style.top = this.currentTop + "px"
        }
        destroy() {
            window.removeEventListener("scroll", this.scrollListener), this.observer && this.observer.disconnect()
        }
    }
    new class e extends l {
        constructor() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "sticky-scroll-direction",
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(e);
            super(e, t)
        }
        init(e) {
            super.init(e), this.registerInstance(e, new u(e))
        }
        destroy(e) {
            this.destroyInstance(e), super.destroy(e)
        }
    }, theme.VideoManager = new function () {
        var t = this;
        t.videos = {
            incrementor: 0,
            videoData: {}
        }, t._loadYoutubeVideos = function (a) {
            e('.video-container[data-video-type="youtube"]:not(.video--init)', a).each(function () {
                e(this).addClass("video--init"), t.videos.incrementor++;
                var a = "theme-yt-video-" + t.videos.incrementor;
                e(this).data("video-container-id", a);
                var o = e(this).data("video-autoplay"),
                    n = e(this).data("video-loop"),
                    s = e(this).data("video-id"),
                    r = e(this).hasClass("video-container--background"),
                    l = new URLSearchParams("iv_load_policy=3&modestbranding=1&rel=0&showinfo=0&enablejsapi=1&playslinline=1");
                l.append("origin", location.origin), l.append("playlist", s), l.append("loop", n ? 1 : 0), l.append("autoplay", 0), l.append("controls", r ? 0 : 1);
                var c = t.videos.incrementor;
                l.append("widgetid", c);
                var d = "https://www.youtube.com/embed/" + s + "?" + l.toString(),
                    h = e('<iframe class="video-container__video-element" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">').attr({
                        id: a,
                        width: 640,
                        height: 360,
                        tabindex: r ? "-1" : null
                    }).appendTo(e(".video-container__video", this));
                t.videos.videoData[a] = {
                    type: "yt",
                    id: a,
                    container: this,
                    mute: () => h[0].contentWindow.postMessage('{"event":"command","func":"mute","args":""}', "*"),
                    play: () => h[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*"),
                    pause: () => h[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*"),
                    stop: () => h[0].contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', "*"),
                    seekTo: e => h[0].contentWindow.postMessage('{"event":"command","func":"seekTo","args":'.concat(e, "}"), "*"),
                    videoElement: h[0],
                    isBackgroundVideo: r,
                    establishedYTComms: !1
                }, o && h.on("load", () => setTimeout(() => {
                    window.addEventListener("message", o => {
                        if ("https://www.youtube.com" === o.origin && o.data && "string" == typeof o.data) {
                            var s = JSON.parse(o.data);
                            "initialDelivery" === s.event && s.info && s.info.duration && (t.videos.videoData[a].duration = s.info.duration), "infoDelivery" === s.event && "widget" === s.channel && s.id === c && (t.videos.videoData[a].establishedYTComms = !0, s.info && 1 === s.info.playerState && e(this).addClass("video-container--playing"), n && s.info && s.info.currentTime > t.videos.videoData[a].duration - 1 && t.videos.videoData[a].seekTo(0))
                        }
                    }), h[0].contentWindow.postMessage('{"event":"listening","id":'.concat(c, ',"channel":"widget"}'), "*"), t.videos.videoData[a].mute(), t.videos.videoData[a].play(), setTimeout(() => {
                        t.videos.videoData[a].establishedYTComms || e(this).addClass("video-container--playing")
                    }, 2e3)
                }, 100)), r && (h.attr("tabindex", "-1"), t._initBackgroundVideo(t.videos.videoData[a]), t.addYTPageshowListenerHack()), h.attr("src", d), fetch("https://www.youtube.com/oembed?format=json&url=" + encodeURIComponent(e(this).data("video-url"))).then(e => {
                    if (!e.ok) throw Error("HTTP error! Status: ".concat(e.status));
                    return e.json()
                }).then(e => {
                    e.width && e.height && (h.attr({
                        width: e.width,
                        height: e.height
                    }), t.videos.videoData[a].assessBackgroundVideo && t.videos.videoData[a].assessBackgroundVideo())
                })
            })
        }, t._loadVimeoVideos = function (a) {
            e('.video-container[data-video-type="vimeo"]:not(.video--init)', a).each(function () {
                e(this).addClass("video--init"), t.videos.incrementor++;
                var a = "theme-vi-video-" + t.videos.incrementor;
                e(this).data("video-container-id", a);
                var o = e(this).data("video-autoplay"),
                    n = e(this).data("video-loop"),
                    s = e(this).data("video-id"),
                    r = e(this).hasClass("video-container--background"),
                    l = new URLSearchParams;
                o && l.append("muted", 1), n && l.append("loop", 1), r && l.append("controls", 0);
                var c = "https://player.vimeo.com/video/" + s + "?" + l.toString(),
                    d = e('<iframe class="video-container__video-element" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">').attr({
                        id: a,
                        width: 640,
                        height: 360,
                        tabindex: r ? "-1" : null
                    }).appendTo(e(".video-container__video", this));
                t.videos.videoData[a] = {
                    type: "vimeo",
                    id: a,
                    container: this,
                    play: () => d[0].contentWindow.postMessage('{"method":"play"}', "*"),
                    pause: () => d[0].contentWindow.postMessage('{"method":"pause"}', "*"),
                    videoElement: d[0],
                    isBackgroundVideo: r,
                    establishedVimeoComms: !1
                }, o && d.on("load", () => setTimeout(() => {
                    window.addEventListener("message", o => {
                        if ("https://player.vimeo.com" === o.origin && o.source === d[0].contentWindow && o.data) {
                            var n = o.data;
                            "string" == typeof n && (n = JSON.parse(n)), ("ping" === n.method || "playing" === n.event) && (t.videos.videoData[a].establishedVimeoComms = !0), "playing" === n.event && e(this).addClass("video-container--playing")
                        }
                    }), d[0].contentWindow.postMessage({
                        method: "addEventListener",
                        value: "playing"
                    }, "*"), d[0].contentWindow.postMessage({
                        method: "appendVideoMetadata",
                        value: location.origin
                    }, "*"), d[0].contentWindow.postMessage({
                        method: "ping"
                    }, "*"), t.videos.videoData[a].play(), setTimeout(() => {
                        t.videos.videoData[a].establishedVimeoComms || e(this).addClass("video-container--playing")
                    }, 2e3)
                }, 100)), r && (d.attr("tabindex", "-1"), t._initBackgroundVideo(t.videos.videoData[a])), d.attr("src", c), fetch("https://vimeo.com/api/oembed.json?url=" + encodeURIComponent(e(this).data("video-url"))).then(e => {
                    if (!e.ok) throw Error("HTTP error! Status: ".concat(e.status));
                    return e.json()
                }).then(e => {
                    e.width && e.height && (d.attr({
                        width: e.width,
                        height: e.height
                    }), t.videos.videoData[a].assessBackgroundVideo && t.videos.videoData[a].assessBackgroundVideo())
                })
            })
        }, t._loadMp4Videos = function (a) {
            e('.video-container[data-video-type="mp4"]:not(.video--init)', a).addClass("video--init").each(function () {
                t.videos.incrementor++;
                var o = "theme-mp-video-" + t.videos.incrementor,
                    n = e(this);
                e(this).data("video-container-id", o);
                var s = e('<div class="video-container__video-element">').attr("id", o).appendTo(e(".video-container__video", this)),
                    r = e(this).data("video-autoplay"),
                    l = e(this).hasClass("video-container--background"),
                    c = e("<video playsinline>");
                e(this).data("video-loop") && c.attr("loop", "loop"), c.on("click mouseenter", () => c.attr("controls", "controls")), r && (c.attr({
                    autoplay: "autoplay",
                    muted: "muted"
                }), c[0].muted = !0, c.one("loadeddata", function () {
                    this.play(), n.addClass("video-container--playing")
                })), c.attr("src", e(this).data("video-url")).appendTo(s);
                var d = t.videos.videoData[o] = {
                    type: "mp4",
                    element: c[0],
                    play: () => c[0].play(),
                    pause: () => c[0].pause(),
                    isBackgroundVideo: l
                };
                l && (c.attr("tabindex", "-1"), r && a.addEventListener("click", d.play, {
                    once: !0
                }))
            })
        }, t._initBackgroundVideo = function (t) {
            t.container.classList.contains("video-container--background") && (t.assessBackgroundVideo = (function () {
                var e = this.offsetWidth,
                    t = this.offsetHeight,
                    a = this.querySelector("iframe"),
                    o = parseFloat(a.width) / parseFloat(a.height),
                    n = this.querySelector(".video-container__video");
                if (e / t > o) {
                    var s = e / o + 150;
                    n.style.marginTop = (t - s) / 2 - 75 + "px", n.style.marginInlineStart = "", n.style.height = s + 150 + "px", n.style.width = ""
                } else {
                    var r = t + 150,
                        l = r * o;
                    n.style.marginTop = "-75px", n.style.marginInlineStart = (e - l) / 2 + "px", n.style.height = r + "px", n.style.width = l + "px"
                }
            }).bind(t.container), t.assessBackgroundVideo(), e(window).on("debouncedresize." + t.id, t.assessBackgroundVideo), t.container.addEventListener("click", t.play, {
                once: !0
            }))
        }, t._unloadVideos = function (a) {
            for (var o in t.videos.videoData) {
                var n = t.videos.videoData[o];
                if (e(a).find(n.container).length) {
                    delete t.videos.videoData[o];
                    return
                }
            }
        }, this.onSectionLoad = function (a) {
            e(".video-container[data-video-url]:not([data-video-type])").each(function () {
                var t = e(this).data("video-url");
                t.indexOf(".mp4") > -1 && e(this).attr("data-video-type", "mp4"), t.indexOf("vimeo.com") > -1 && (e(this).attr("data-video-type", "vimeo"), e(this).attr("data-video-id", t.split("?")[0].split("/").pop())), (t.indexOf("youtu.be") > -1 || t.indexOf("youtube.com") > -1) && (e(this).attr("data-video-type", "youtube"), t.indexOf("v=") > -1 ? e(this).attr("data-video-id", t.split("v=").pop().split("&")[0]) : e(this).attr("data-video-id", t.split("?")[0].split("/").pop()))
            }), t._loadYoutubeVideos(a), t._loadVimeoVideos(a), t._loadMp4Videos(a), e(".video-container__play", a).on("click", function (a) {
                a.preventDefault();
                var o = e(this).closest(".video-container");
                o.addClass("video-container--playing"), o.trigger("cc:video:play");
                var n = o.data("video-container-id");
                t.videos.videoData[n].play()
            }), e(".video-container__stop", a).on("click", function (a) {
                a.preventDefault();
                var o = e(this).closest(".video-container");
                o.removeClass("video-container--playing"), o.trigger("cc:video:stop");
                var n = o.data("video-container-id");
                t.videos.videoData[n].pause()
            })
        }, this.onSectionUnload = function (a) {
            e(".video-container__play, .video-container__stop", a).off("click"), e(window).off("." + e(".video-container").data("video-container-id")), e(window).off("debouncedresize.video-manager-resize"), t._unloadVideos(a), e(a).trigger("cc:video:stop")
        }, t.addYTPageshowListenerHack = function () {
            t.pageshowListenerAdded || (t.pageshowListenerAdded = !0, window.addEventListener("pageshow", e => {
                e.persisted && Object.keys(t.videos.videoData).filter(e => "yt" === t.videos.videoData[e].type && t.videos.videoData[e].isBackgroundVideo).forEach(e => {
                    t.videos.videoData[e].stop(), t.videos.videoData[e].play()
                })
            }))
        }
    }, r.sections.push({
        name: "video",
        section: theme.VideoManager
    }), theme.MapSection = new function () {
        var t = this;
        t.config = {
            zoom: 14,
            styles: {
                default: [],
                silver: [{
                    elementType: "geometry",
                    stylers: [{
                        color: "#f5f5f5"
                    }]
                }, {
                    elementType: "labels.icon",
                    stylers: [{
                        visibility: "off"
                    }]
                }, {
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#616161"
                    }]
                }, {
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#f5f5f5"
                    }]
                }, {
                    featureType: "administrative.land_parcel",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#bdbdbd"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [{
                        color: "#eeeeee"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [{
                        color: "#e5e5e5"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#9e9e9e"
                    }]
                }, {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [{
                        color: "#ffffff"
                    }]
                }, {
                    featureType: "road.arterial",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [{
                        color: "#dadada"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#616161"
                    }]
                }, {
                    featureType: "road.local",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#9e9e9e"
                    }]
                }, {
                    featureType: "transit.line",
                    elementType: "geometry",
                    stylers: [{
                        color: "#e5e5e5"
                    }]
                }, {
                    featureType: "transit.station",
                    elementType: "geometry",
                    stylers: [{
                        color: "#eeeeee"
                    }]
                }, {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [{
                        color: "#c9c9c9"
                    }]
                }, {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#9e9e9e"
                    }]
                }],
                retro: [{
                    elementType: "geometry",
                    stylers: [{
                        color: "#ebe3cd"
                    }]
                }, {
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#523735"
                    }]
                }, {
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#f5f1e6"
                    }]
                }, {
                    featureType: "administrative",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#c9b2a6"
                    }]
                }, {
                    featureType: "administrative.land_parcel",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#dcd2be"
                    }]
                }, {
                    featureType: "administrative.land_parcel",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#ae9e90"
                    }]
                }, {
                    featureType: "landscape.natural",
                    elementType: "geometry",
                    stylers: [{
                        color: "#dfd2ae"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [{
                        color: "#dfd2ae"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#93817c"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "geometry.fill",
                    stylers: [{
                        color: "#a5b076"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#447530"
                    }]
                }, {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [{
                        color: "#f5f1e6"
                    }]
                }, {
                    featureType: "road.arterial",
                    elementType: "geometry",
                    stylers: [{
                        color: "#fdfcf8"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [{
                        color: "#f8c967"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#e9bc62"
                    }]
                }, {
                    featureType: "road.highway.controlled_access",
                    elementType: "geometry",
                    stylers: [{
                        color: "#e98d58"
                    }]
                }, {
                    featureType: "road.highway.controlled_access",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#db8555"
                    }]
                }, {
                    featureType: "road.local",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#806b63"
                    }]
                }, {
                    featureType: "transit.line",
                    elementType: "geometry",
                    stylers: [{
                        color: "#dfd2ae"
                    }]
                }, {
                    featureType: "transit.line",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#8f7d77"
                    }]
                }, {
                    featureType: "transit.line",
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#ebe3cd"
                    }]
                }, {
                    featureType: "transit.station",
                    elementType: "geometry",
                    stylers: [{
                        color: "#dfd2ae"
                    }]
                }, {
                    featureType: "water",
                    elementType: "geometry.fill",
                    stylers: [{
                        color: "#b9d3c2"
                    }]
                }, {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#92998d"
                    }]
                }],
                dark: [{
                    elementType: "geometry",
                    stylers: [{
                        color: "#212121"
                    }]
                }, {
                    elementType: "labels.icon",
                    stylers: [{
                        visibility: "off"
                    }]
                }, {
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575"
                    }]
                }, {
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#212121"
                    }]
                }, {
                    featureType: "administrative",
                    elementType: "geometry",
                    stylers: [{
                        color: "#757575"
                    }]
                }, {
                    featureType: "administrative.country",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#9e9e9e"
                    }]
                }, {
                    featureType: "administrative.land_parcel",
                    stylers: [{
                        visibility: "off"
                    }]
                }, {
                    featureType: "administrative.locality",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#bdbdbd"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [{
                        color: "#181818"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#616161"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#1b1b1b"
                    }]
                }, {
                    featureType: "road",
                    elementType: "geometry.fill",
                    stylers: [{
                        color: "#2c2c2c"
                    }]
                }, {
                    featureType: "road",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#8a8a8a"
                    }]
                }, {
                    featureType: "road.arterial",
                    elementType: "geometry",
                    stylers: [{
                        color: "#373737"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [{
                        color: "#3c3c3c"
                    }]
                }, {
                    featureType: "road.highway.controlled_access",
                    elementType: "geometry",
                    stylers: [{
                        color: "#4e4e4e"
                    }]
                }, {
                    featureType: "road.local",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#616161"
                    }]
                }, {
                    featureType: "transit",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575"
                    }]
                }, {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [{
                        color: "#000000"
                    }]
                }, {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#3d3d3d"
                    }]
                }],
                night: [{
                    elementType: "geometry",
                    stylers: [{
                        color: "#242f3e"
                    }]
                }, {
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#746855"
                    }]
                }, {
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#242f3e"
                    }]
                }, {
                    featureType: "administrative.locality",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#d59563"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#d59563"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [{
                        color: "#263c3f"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#6b9a76"
                    }]
                }, {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [{
                        color: "#38414e"
                    }]
                }, {
                    featureType: "road",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#212a37"
                    }]
                }, {
                    featureType: "road",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#9ca5b3"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [{
                        color: "#746855"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#1f2835"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#f3d19c"
                    }]
                }, {
                    featureType: "transit",
                    elementType: "geometry",
                    stylers: [{
                        color: "#2f3948"
                    }]
                }, {
                    featureType: "transit.station",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#d59563"
                    }]
                }, {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [{
                        color: "#17263c"
                    }]
                }, {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#515c6d"
                    }]
                }, {
                    featureType: "water",
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#17263c"
                    }]
                }],
                aubergine: [{
                    elementType: "geometry",
                    stylers: [{
                        color: "#1d2c4d"
                    }]
                }, {
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#8ec3b9"
                    }]
                }, {
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#1a3646"
                    }]
                }, {
                    featureType: "administrative.country",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#4b6878"
                    }]
                }, {
                    featureType: "administrative.land_parcel",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#64779e"
                    }]
                }, {
                    featureType: "administrative.province",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#4b6878"
                    }]
                }, {
                    featureType: "landscape.man_made",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#334e87"
                    }]
                }, {
                    featureType: "landscape.natural",
                    elementType: "geometry",
                    stylers: [{
                        color: "#023e58"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [{
                        color: "#283d6a"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#6f9ba5"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#1d2c4d"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "geometry.fill",
                    stylers: [{
                        color: "#023e58"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#3C7680"
                    }]
                }, {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [{
                        color: "#304a7d"
                    }]
                }, {
                    featureType: "road",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#98a5be"
                    }]
                }, {
                    featureType: "road",
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#1d2c4d"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [{
                        color: "#2c6675"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#255763"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#b0d5ce"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#023e58"
                    }]
                }, {
                    featureType: "transit",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#98a5be"
                    }]
                }, {
                    featureType: "transit",
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#1d2c4d"
                    }]
                }, {
                    featureType: "transit.line",
                    elementType: "geometry.fill",
                    stylers: [{
                        color: "#283d6a"
                    }]
                }, {
                    featureType: "transit.station",
                    elementType: "geometry",
                    stylers: [{
                        color: "#3a4762"
                    }]
                }, {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [{
                        color: "#0e1626"
                    }]
                }, {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#4e6d70"
                    }]
                }]
            }
        }, t.apiStatus = null, this.geolocate = function (t) {
            var a = e.Deferred(),
                o = new google.maps.Geocoder,
                n = t.data("address-setting");
            return o.geocode({
                address: n
            }, function (e, t) {
                t !== google.maps.GeocoderStatus.OK && a.reject(t), a.resolve(e)
            }), a
        }, this.createMap = function (a) {
            var o = e(".map-section__map-container", a);
            return t.geolocate(o).then((function (n) {
                var s = {
                    zoom: t.config.zoom,
                    styles: t.config.styles[e(a).data("map-style")],
                    center: n[0].geometry.location,
                    scrollwheel: !1,
                    disableDoubleClickZoom: !0,
                    disableDefaultUI: !0,
                    zoomControl: !o.data("hide-zoom")
                };
                t.map = new google.maps.Map(o[0], s), t.center = t.map.getCenter(), new google.maps.Marker({
                    map: t.map,
                    position: t.center,
                    clickable: !1
                }), google.maps.event.addDomListener(window, "resize", function () {
                    google.maps.event.trigger(t.map, "resize"), t.map.setCenter(t.center)
                })
            }).bind(this)).fail(function () {
                var e;
                switch (status) {
                    case "ZERO_RESULTS":
                        e = theme.strings.addressNoResults;
                        break;
                    case "OVER_QUERY_LIMIT":
                        e = theme.strings.addressQueryLimit;
                        break;
                    default:
                        e = theme.strings.addressError
                }
                if (Shopify.designMode) {
                    var t = o.parents(".map-section");
                    t.addClass("page-width map-section--load-error"), t.find(".map-section__wrapper").html('<div class="errors text-center">' + e + "</div>")
                }
            })
        }, this.onSectionLoad = function (a) {
            var o = e(a);
            window.gm_authFailure = function () {
                Shopify.designMode && (o.addClass("page-width map-section--load-error"), o.find(".map-section__wrapper").html('<div class="errors text-center">' + theme.strings.authError + "</div>"))
            };
            var n = o.data("api-key");
            "string" == typeof n && "" !== n && theme.loadScriptOnce("https://maps.googleapis.com/maps/api/js?key=" + n, function () {
                t.createMap(o)
            })
        }, this.onSectionUnload = function (e) {
            void 0 !== window.google && void 0 !== google.maps && google.maps.event.clearListeners(t.map, "resize")
        }
    }, r.sections.push({
        name: "map",
        section: theme.MapSection
    }), theme.Popup = new function () {
        var t = "cc-theme-popup-dismissed";
        this.onSectionLoad = function (a) {
            this.namespace = theme.namespaceFromSection(a), this.$container = e(a), this.popup = new c(this.$container, this.namespace);
            var o = this.$container.data("dismiss-for-days"),
                n = this.$container.data("delay-seconds"),
                s = !0,
                r = this.$container.data("test-mode"),
                l = window.localStorage.getItem(t);
            l && (new Date().getTime() - l) / 864e5 < o && (s = !1), this.$container.find(".cc-popup-form__response").length && (s = !0, n = 1, this.$container.find(".cc-popup-form__response--success").length && this.functions.popupSetAsDismissed.call(this)), document.querySelector(".shopify-challenge__container") && (s = !1), (s || r) && setTimeout(() => {
                this.popup.open()
            }, 1e3 * n), this.$container.on("click" + this.namespace, ".cc-popup-close, .cc-popup-background", () => {
                this.popup.close(() => {
                    this.functions.popupSetAsDismissed.call(this)
                })
            })
        }, this.onSectionSelect = function () {
            this.popup.open()
        }, this.functions = {
            popupSetAsDismissed: function e() {
                window.localStorage.setItem(t, new Date().getTime())
            }
        }, this.onSectionUnload = function () {
            this.$container.off(this.namespace)
        }
    }, r.sections.push({
        name: "newsletter-popup",
        section: theme.Popup
    }), theme.StoreAvailability = function (t) {
        var a = "store-availability-loading",
            o = "cc-location";
        this.onSectionLoad = function (t) {
            this.namespace = theme.namespaceFromSection(t), this.$container = e(t), this.productId = this.$container.data("store-availability-container"), this.sectionUrl = this.$container.data("section-url"), this.$modal, this.$container.addClass("store-availability-initialized"), this.transitionDurationMS = 1e3 * parseFloat(getComputedStyle(t).transitionDuration), this.removeFixedHeightTimeout = -1, e(window).on("cc-variant-updated".concat(this.namespace).concat(this.productId), (e, t) => {
                t.product.id === this.productId && this.functions.updateContent.bind(this)(t.variant ? t.variant.id : null, t.product.title, this.$container.data("has-only-default-variant"), t.variant && void 0 !== t.variant.available)
            }), this.$container.data("single-variant-id") && this.functions.updateContent.bind(this)(this.$container.data("single-variant-id"), this.$container.data("single-variant-product-title"), this.$container.data("has-only-default-variant"), this.$container.data("single-variant-product-available"))
        }, this.onSectionUnload = function () {
            e(window).off("cc-variant-updated".concat(this.namespace).concat(this.productId)), this.$container.off("click"), this.$modal && this.$modal.off("click")
        }, this.functions = {
            getUserLocation: function e() {
                return new Promise((e, t) => {
                    var a;
                    sessionStorage[o] && (a = JSON.parse(sessionStorage[o])), a ? e(a) : navigator.geolocation ? navigator.geolocation.getCurrentPosition(function (t) {
                        var a = {
                            latitude: t.coords.latitude,
                            longitude: t.coords.longitude
                        };
                        fetch("/localization.json", {
                            method: "PUT",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(a)
                        }), sessionStorage[o] = JSON.stringify(a), e(a)
                    }, function () {
                        e(!1)
                    }, {
                        maximumAge: 36e5,
                        timeout: 5e3
                    }) : e(!1)
                })
            },
            getAvailableStores: function t(a, o) {
                return e.get(this.sectionUrl.replace("VARIANT_ID", a), o)
            },
            calculateDistance: function e(t, a, o) {
                var n, s = Math.PI / 180,
                    r = t.latitude * s,
                    l = t.longitude * s,
                    c = a.latitude * s,
                    d = Math.pow(Math.sin((r - c) / 2), 2) + Math.cos(r) * Math.cos(c) * Math.pow(Math.sin((l - a.longitude * s) / 2), 2);
                return ("metric" === o ? 6378.14 : 3959) * (2 * Math.atan2(Math.sqrt(d), Math.sqrt(1 - d)))
            },
            updateLocationDistances: function t(a) {
                var o = this.$modal.find("[data-unit-system]").data("unit-system"),
                    n = this;
                this.$modal.find('[data-distance="false"]').each(function () {
                    var t = {
                        latitude: parseFloat(e(this).data("latitude")),
                        longitude: parseFloat(e(this).data("longitude"))
                    };
                    if (t.latitude && t.longitude) {
                        var s = n.functions.calculateDistance(a, t, o).toFixed(1);
                        e(this).html(s), setTimeout(() => {
                            e(this).closest(".store-availability-list__location__distance").addClass("-in")
                        }, 0)
                    }
                    e(this).attr("data-distance", "true")
                })
            },
            updateContent: function t(o, n, s, r) {
                this.$container.off("click", "[data-store-availability-modal-open]"), this.$container.off("click" + this.namespace, ".cc-popup-close, .cc-popup-background"), e(".store-availabilities-modal").remove(), r ? (this.$container.addClass(a), this.transitionDurationMS > 0 && this.$container.css("height", this.$container.outerHeight() + "px")) : (this.$container.addClass(a), this.transitionDurationMS > 0 && this.$container.css("height", "0px")), r && this.functions.getAvailableStores.call(this, o, t => {
                    if (t.trim().length > 0 && !t.includes("NO_PICKUP")) {
                        this.$container.html(t), this.$container.html(this.$container.children().first().html()), this.$container.find("[data-store-availability-modal-product-title]").html(n), s && this.$container.find(".store-availabilities-modal__variant-title").remove(), this.$container.find(".cc-popup").appendTo("body"), this.$modal = e("body").find(".store-availabilities-modal");
                        var r = new c(this.$modal, this.namespace);
                        if (this.$container.on("click", "[data-store-availability-modal-open]", () => (r.open(), this.functions.getUserLocation().then(t => {
                                t && this.$modal.find('[data-distance="false"]').length && this.functions.getAvailableStores.call(this, o, a => {
                                    this.$modal.find(".store-availabilities-list").html(e(a).find(".store-availabilities-list").html()), this.functions.updateLocationDistances.bind(this)(t)
                                })
                            }), !1)), this.$modal.on("click" + this.namespace, ".cc-popup-close, .cc-popup-background", () => {
                                r.close()
                            }), this.$container.removeClass(a), this.transitionDurationMS > 0) {
                            var l = this.$container.find(".store-availability-container").outerHeight();
                            this.$container.css("height", l > 0 ? l + "px" : ""), clearTimeout(this.removeFixedHeightTimeout), this.removeFixedHeightTimeout = setTimeout(() => {
                                this.$container.css("height", "")
                            }, this.transitionDurationMS)
                        }
                    }
                })
            }
        }, this.onSectionLoad(t)
    }, r.sections.push({
        name: "store-availability",
        section: theme.StoreAvailability
    }), /\/$/.test(theme.routes.root_url) || (theme.routes.root_url += "/");
    class p {
        static set(e, t) {
            theme.device.isLocalStorageAvailable() && localStorage.setItem(e, "object" == typeof t ? JSON.stringify(t) : t)
        }
        static get(e, t) {
            if (theme.device.isLocalStorageAvailable()) {
                var a = localStorage.getItem(e);
                return t && (a = JSON.parse(a)), a
            }
        }
    }
    theme.icons = {
        left: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>',
        right: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>',
        close: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
        chevronLightLeft: '<svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 14.51,6.51 14,6 8,12 14,18 14.51,17.49 9.03,12 Z"></path></svg>',
        chevronLightRight: '<svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 10,6 9.49,6.51 14.97,12 9.49,17.49 10,18 16,12 Z"></path></svg>',
        chevronDown: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>',
        tick: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>',
        add: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
        loading: '<svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: transparent; display: block; shape-rendering: auto;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="currentColor" stroke-width="5" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(263.279 50 50)"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle></svg>',
        chevronRight: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"></path><polyline points="10 17.83 15.4 12.43 10 7.03" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:1.5px"></polyline></svg>',
        chevronLeft: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"/> <polyline points="14.4 7.03 9 12.43 14.4 17.83" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:1.5px"/></svg>'
    }, theme.swipers = {}, theme.productData = {}, theme.viewport = {
        isXs: () => 768 > e(window).outerWidth(),
        isSm: () => e(window).outerWidth() >= 768,
        isMd: () => e(window).outerWidth() >= 992,
        isLg: () => e(window).outerWidth() >= 1200,
        isXlg: () => e(window).outerWidth() >= 1441,
        scroll: {
            currentScrollTop: -1,
            to: function t(a) {
                var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1,
                    n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
                    s = arguments.length > 3 ? arguments[3] : void 0;
                if (a && "string" == typeof a && (a = e(a)), -1 === o && a && a.length) {
                    var r = theme.Nav().bar.isInline() ? 0 : theme.Nav().bar.height();
                    o = a.offset().top - r - n
                }
                e("html,body").animate({
                    scrollTop: o
                }, 700, () => {
                    s && s()
                })
            },
            lock() {
                theme.viewport.scroll.currentScrollTop = window.scrollY, document.body.style.top = -window.scrollY + "px", document.body.style.width = "100%", document.body.style.position = "fixed", document.body.scrollHeight > window.outerHeight && (document.body.style.overflowY = "scroll")
            },
            unlock() {
                document.body.style.top = null, document.body.style.overflowY = null, document.body.style.width = null, document.body.style.position = null, window.scrollTo({
                    top: theme.viewport.scroll.currentScrollTop,
                    behavior: "instant"
                })
            }
        }
    }, theme.device = {
        cache: {
            isTouch: null,
            isRetinaDisplay: null
        },
        isTouch() {
            if (null !== theme.device.cache.isTouch) return theme.device.cache.isTouch;
            try {
                document.createEvent("TouchEvent"), theme.device.cache.isTouch = !0
            } catch (e) {
                theme.device.cache.isTouch = !1
            } finally {
                return theme.device.cache.isTouch
            }
        },
        isRetinaDisplay() {
            if (null !== theme.device.cache.isRetinaDisplay) return theme.device.cache.isRetinaDisplay;
            if (window.matchMedia) {
                var e = window.matchMedia("only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)");
                theme.device.cache.isRetinaDisplay = e && e.matches || window.devicePixelRatio > 1
            } else theme.device.cache.isRetinaDisplay = !1;
            return theme.device.cache.isRetinaDisplay
        },
        isLocalStorageAvailable() {
            try {
                return localStorage.setItem("a", "a"), localStorage.removeItem("a"), !0
            } catch (e) {
                return !1
            }
        }
    }, window.Element && !Element.prototype.closest && (Element.prototype.closest = function (e) {
        var t, a = (this.document || this.ownerDocument).querySelectorAll(e),
            o = this;
        do
            for (t = a.length; --t >= 0 && a.item(t) !== o;); while (t < 0 && (o = o.parentElement));
        return o
    });
    var f = class extends HTMLElement {
        connectedCallback() {
            fetch(this.dataset.url).then(e => {
                if (!e.ok) throw Error("HTTP error! Status: ".concat(e.status));
                return e.text()
            }).then(t => {
                var a = document.createDocumentFragment(),
                    o = document.createElement("div");
                a.appendChild(o), o.innerHTML = t;
                var n = o.querySelector('[data-id="'.concat(CSS.escape(this.dataset.id), '"]'));
                if (n && (this.innerHTML = n.innerHTML, this.hasAttribute("contains-product-blocks"))) {
                    var s = this.querySelector(".swiper-container");
                    s && theme.initProductSlider(e(s))
                }
            })
        }
    };
    window.customElements.define("cc-fetched-content", f), theme.Nav = function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : e("#site-control");
        return {
            bar: {
                turnOpaque(e) {
                    e ? t.addClass("nav-opaque") : t.removeClass("nav-opaque")
                },
                hide(e) {
                    e ? t.addClass("nav-hidden") : t.removeClass("nav-hidden")
                },
                fadeOut(e) {
                    e ? t.addClass("nav-fade-out") : t.removeClass("nav-fade-out")
                },
                hideAnnouncement(e) {
                    e ? t.addClass("announcement-hidden") : t.removeClass("announcement-hidden")
                },
                hasOpaqueSetting: () => e("#site-control").data("opacity").includes("opaque"),
                hasStickySetting: () => "sticky" === e("#site-control").data("positioning"),
                isInline: () => "inline" === e("#site-control").data("positioning"),
                hasInlineLinks: () => 1 === e("#site-control.nav-inline-desktop").length,
                getPositionSetting: () => e("#site-control").data("positioning"),
                getOpacitySetting: () => e("#site-control").data("opacity"),
                isCurrentlyOpaque: () => e("#site-control").hasClass("nav-opaque"),
                isAnnouncementBar: () => 1 === e("#site-control").find(".cc-announcement__inner").length,
                hasLocalization: () => e("#site-control").hasClass("has-localization"),
                heightExcludingAnnouncementBar: () => Math.round(e("#site-control").find(".site-control__inner").outerHeight()),
                heightOfAnnouncementBar: () => Math.round(e("#site-control").find(".announcement").outerHeight()),
                height() {
                    var t, a = e("#site-control");
                    return a.hasClass("announcement-hidden") && a.find(".cc-announcement__inner").length ? Math.round(a.find(".cc-announcement__inner").outerHeight() + a.find(".site-control__inner").outerHeight()) : Math.round(a.outerHeight())
                }
            }
        }
    }, theme.ProductMediaGallery = function (t, a, o, n, s) {
        var r, l, c = this,
            d = {},
            h = t.find(".view-in-space"),
            u = t.find(".swiper-container"),
            f = !1,
            m = !1,
            v = !0,
            g = t.find(".theme-img:visible").length,
            y = "carousel" === t.data("layout"),
            $ = t.closest(".product-area").hasClass("product-area--restrict-width"),
            b = t.closest(".product-area").find(".product-area__thumbs"),
            w = t.data("variant-image-grouping"),
            S = t.data("underline-selected-media"),
            _ = theme.Nav();

        function C() {
            var a = theme.Nav();
            e("body").toggleClass("header-over-gallery", e(window).scrollTop() < t.height() - a.bar.height())
        }

        function T() {
            var a, o = t.data("column-count"),
                n = "collage" === t.data("layout");
            n && t.find(".theme-img:visible").first().addClass("theme-img--collage-full");
            var s, r = t.find(".theme-img:visible:not(.theme-img--collage-full)"),
                l = 0;
            r.length % 2 > 0 && n && (s = r.children().last(), l = 1);
            var c = Math.ceil((r.length - l) / o),
                d = t.find(".theme-images"),
                h = -1;
            o > 1 && r.length - l > 1 && r.each(function (t) {
                (0 === l || t < r.length - l) && (h < Math.floor(t / c) && (a = e('<div class="media-column"></div>').appendTo(d), h++), e(this).appendTo(a))
            }), s && s.parent().addClass("theme-img--collage-full").addClass("theme-img--collage-last").appendTo(d)
        }

        function k() {
            var a = t.find(".theme-images");
            a.find(".theme-img").each(function () {
                e(this).appendTo(a).removeClass("theme-img--collage-full").removeClass("theme-img--collage-last")
            }), e(window).off("debouncedresize.columnheights"), a.find(".media-column").remove()
        }
        this.Image = function (e, a) {
            this.show = function () {
                e.addClass("product-media--activated"), e.show()
            }, this.play = function () {
                t.find(".product-media--current").removeClass("product-media--current"), e.addClass("product-media--current")
            }, this.destroy = function () {}, this.pause = function () {
                e.removeClass("product-media--activated")
            }, this.hide = function () {
                e.hide()
            }, this.show()
        }, this.Video = function (a, o) {
            var n = this,
                s = {
                    play: function e() {},
                    pause: function e() {},
                    destroy: function e() {}
                },
                r = a.find("video")[0];

            function l() {
                c.pauseAllMedia(a.data("media-id"))
            }

            function h(e) {
                f = !0, window.innerHeight !== screen.height && setTimeout(function () {
                    f = !0
                }, 200)
            }
            this.show = function () {
                a.addClass("product-media--activated"), a.show(), c.slideshowTabFix()
            }, this.play = function () {
                t.find(".product-media--current").removeClass("product-media--current"), a.addClass("product-media--current"), n.show(), s.play()
            }, this.pause = function () {
                s.pause(), a.removeClass("product-media--activated")
            }, this.hide = function () {
                s.pause(), a.hide()
            }, this.destroy = function () {
                s.destroy(), e(r).off("playing", l), e(document).off("fullscreenchange", h)
            }, theme.loadStyleOnce("https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css"), window.Shopify.loadFeatures([{
                name: "video-ui",
                version: "1.0",
                onLoad: (function () {
                    s = {
                        playerType: "html5",
                        element: r,
                        plyr: new Shopify.Plyr(r, {
                            controls: ["play", "progress", "mute", "volume", "play-large", "fullscreen"],
                            loop: {
                                active: a.data("enable-video-looping")
                            },
                            autoplay: theme.viewport.isSm() && o,
                            hideControlsOnPause: !0,
                            iconUrl: "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg",
                            tooltips: {
                                controls: !1,
                                seek: !0
                            }
                        }),
                        play: function e() {
                            this.plyr.play()
                        },
                        pause: function e() {
                            this.plyr.pause()
                        },
                        destroy: function e() {
                            this.plyr.destroy()
                        }
                    }, a.addClass("product-media--video-loaded"), a.find(".plyr__controls").addClass("swiper-no-swiping"), d[a.data("media-id")] = n
                }).bind(this)
            }]), e(r).on("playing", l), e(document).on("fullscreenchange", h), n.show()
        }, this.ExternalVideo = function (a, o) {
            var n = !1,
                s = this,
                r = {
                    play: function e() {},
                    pause: function e() {},
                    destroy: function e() {}
                },
                l = a.find("iframe")[0];
            if (this.play = function () {
                    t.find(".product-media--current").removeClass("product-media--current"), a.addClass("product-media--current"), s.show(), r.play()
                }, this.togglePlayPause = function () {
                    n ? s.pause() : s.play()
                }, this.pause = function () {
                    r.pause(), a.removeClass("product-media--activated")
                }, this.show = function () {
                    a.addClass("product-media--activated"), a.show(), c.slideshowTabFix()
                }, this.hide = function () {
                    r.pause(), a.hide()
                }, this.destroy = function () {
                    r.destroy(), a.off("click", ".product-media--video-mask", s.togglePlayPause)
                }, /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(l.src)) {
                var h = function e() {
                    r = {
                        playerType: "youtube",
                        element: l,
                        player: new YT.Player(l, {
                            videoId: a.data("video-id"),
                            events: {
                                onReady: function e() {
                                    d[a.data("media-id")] = s, a.addClass("product-media--video-loaded"), o && theme.viewport.isSm() && s.play()
                                },
                                onStateChange: function e(t) {
                                    1 === t.data && c.pauseAllMedia(a.data("media-id")), n = t.data === YT.PlayerState.PLAYING || t.data === YT.PlayerState.BUFFERING || t.data === YT.PlayerState.UNSTARTED, 0 === t.data && a.data("enable-video-looping") && t.target.seekTo(0)
                                }
                            }
                        }),
                        play: function e() {
                            this.player.playVideo()
                        },
                        pause: function e() {
                            this.player.pauseVideo()
                        },
                        destroy: function e() {
                            this.player.destroy()
                        }
                    }
                };
                if (window.YT && window.YT.Player) h();
                else {
                    var u = window.onYouTubeIframeAPIReady;
                    window.onYouTubeIframeAPIReady = function () {
                        u && u(), h()
                    }, theme.loadScriptOnce("https://www.youtube.com/iframe_api")
                }
            } else /vimeo\.com/.test(l.src) && function t() {
                m ? (a.data("enable-video-looping") && l.setAttribute("src", l.getAttribute("src") + "&loop=1"), o && e(window).width() >= 768 && l.setAttribute("src", l.getAttribute("src") + "&autoplay=1&muted=1"), (r = {
                    playerType: "vimeo",
                    element: l,
                    player: new Vimeo.Player(l),
                    play: function e() {
                        this.player.play()
                    },
                    pause: function e() {
                        this.player.pause()
                    },
                    destroy: function e() {
                        this.player.destroy()
                    }
                }).player.ready().then(function () {
                    d[a.data("media-id")] = s, a.addClass("product-media--video-loaded")
                })) : theme.loadScriptOnce("https://player.vimeo.com/api/player.js", function () {
                    m = !0, t()
                })
            }();
            a.on("click", ".product-media--video-mask", s.togglePlayPause), s.show()
        }, this.Model = function (a, o) {
            var n = this,
                s = {
                    play: function e() {},
                    pause: function e() {},
                    destroy: function e() {}
                },
                r = a.find("model-viewer")[0];
            this.show = function () {
                a.show(), a.addClass("product-media--activated"), c.slideshowTabFix(), n.updateViewInSpaceButton()
            }, this.updateViewInSpaceButton = function () {
                window.ShopifyXR && h.length && (h.attr("data-shopify-model3d-id", a.data("media-id")), window.ShopifyXR.setupXRElements())
            }, this.play = function () {
                t.find(".product-media--current").removeClass("product-media--current"), a.addClass("product-media--current"), n.show(), s.play()
            }, this.pause = function () {
                a.removeClass("product-media--activated"), s.pause()
            }, this.hide = function () {
                s.pause(), a.hide(), window.ShopifyXR && h.length && (h.attr("data-shopify-model3d-id", h.data("shopify-model3d-first-id")), h.attr("data-shopify-title", h.data("shopify-first-title")), window.ShopifyXR.setupXRElements())
            }, this.destroy = function () {}, this.initAugmentedReality = function () {
                if (e(".model-json", t).length) {
                    var a = function a() {
                        if (!window.ShopifyXR) {
                            document.addEventListener("shopify_xr_initialized", function e(t) {
                                a(), t.target.removeEventListener(t.type, e)
                            });
                            return
                        }
                        window.ShopifyXR.addModels(JSON.parse(e(".model-json", t).html())), window.ShopifyXR.setupXRElements()
                    };
                    window.Shopify.loadFeatures([{
                        name: "shopify-xr",
                        version: "1.0",
                        onLoad: a
                    }])
                }
            }, theme.loadStyleOnce("https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"), window.Shopify.loadFeatures([{
                name: "model-viewer-ui",
                version: "1.0",
                onLoad: (function () {
                    s = new Shopify.ModelViewerUI(r), a.addClass("product-media--model-loaded"), o && theme.viewport.isSm() && n.play(), e('<div class="theme-event-proxy">').on("mouseup", function (e) {
                        e.stopPropagation(), e.preventDefault(), document.dispatchEvent(new MouseEvent("mouseup"))
                    }).appendTo(e(this).find(".shopify-model-viewer-ui__controls-overlay")), a.find("button").attr("type", "button"), a.find(".shopify-model-viewer-ui").addClass("swiper-no-swiping")
                }).bind(this)
            }]), a.find("model-viewer").on("shopify_model_viewer_ui_toggle_play", function () {
                c.pauseAllMedia(a.data("media-id")), a.addClass("product-media-model--playing"), t.on("click", '.product-media:not([data-media-type="model"])', n.pause)
            }), a.find("model-viewer").on("shopify_model_viewer_ui_toggle_pause", function () {
                a.removeClass("product-media-model--playing"), t.off("click", '.product-media:not([data-media-type="model"])', n.pause)
            }), a.on("click", ".product-media--model-mask", function () {
                y ? (c.swipeToSlideIfNotCurrent(a), setTimeout(n.play, 500)) : n.play()
            }), d[a.data("media-id")] = n, n.show(), window.ShopifyXR || n.initAugmentedReality()
        }, this.pauseAllMedia = function (e) {
            for (var t in d) d.hasOwnProperty(t) && (!e || t != e) && d[t].pause()
        }, this.showMedia = function (e, a, o) {
            if (e.length) {
                r && !o && r.pause();
                var n = function t(o) {
                    var n;
                    return d.hasOwnProperty(e.data("media-id")) ? (n = d[e.data("media-id")], a && theme.viewport.isSm() ? (n.show(), setTimeout(n.play, 250)) : n.show()) : n = new o(e, a), n
                };
                "image" === e.data("media-type") ? r = n(c.Image) : "video" === e.data("media-type") ? r = n(c.Video) : "external_video" === e.data("media-type") ? r = n(c.ExternalVideo) : "model" === e.data("media-type") ? r = n(c.Model) : (console.warn("Media is unknown", e), t.find(".product-media:visible").hide(), e.show())
            }
        }, this.swipeToSlideIfNotCurrent = function (e) {
            var t = e.closest(".swiper-slide");
            l.slideTo(t.index(), 500)
        }, this.destroy = function () {
            for (var o = 0; o < d.length; o++) d[o].destroy();
            y || e(window).off("load.productTemplateGallery".concat(s, " scroll.productTemplateGallery").concat(s), C), t.closest(".product-area").off("click", ".product-area__thumbs__thumb a", L), t.off("click", "[data-full-size]", E), t.off("variantImageSelected", c.pauseAllMedia), e(window).off("ccScrollToMedia.productTemplateGallery".concat(s)), e(window).off(".".concat(s)), a && a.length && a.off("click"), z(), k(), b.length && (e(".carousel-wrapper .carousel", b).off("init reInit setPosition"), e(".slick-slider", b).slick("unslick"), e(window).off("resize.thumbHeight"), e(window).off("debouncedresizewidth.thumbHeight"))
        }, this.slideshowTabFix = function () {
            if (l) {
                var t = u.find(".product-media--current"),
                    a = null;
                (a = t.length ? t.closest(".swiper-slide") : u.find(".swiper-slide.swiper-slide-active")).find("a, input, button, select, iframe, video, model-viewer, [tabindex]").each(function () {
                    void 0 !== e(this).data("theme-slideshow-original-tabindex") ? !1 === e(this).data("theme-slideshow-original-tabindex") ? e(this).removeAttr("tabindex") : e(this).attr("tabindex", e(this).data("theme-slideshow-original-tabindex")) : e(this).removeAttr("tabindex")
                }), e(u.find(".swiper-slide")).not(a).find("a, input, button, select, iframe, video, model-viewer, [tabindex]").each(function () {
                    void 0 === e(this).data("theme-slideshow-original-tabindex") && e(this).data("theme-slideshow-original-tabindex", void 0 !== e(this).attr("tabindex") && e(this).attr("tabindex")), e(this).attr("tabindex", "-1")
                })
            }
        }, this.scrollToMedia = function (a) {
            var o = e('[data-media-id="'.concat(a, '"]'));
            if (o.length && (e("body").hasClass("template-product") || n) && theme.viewport.isSm()) {
                var s, r = parseInt(t.find(".theme-images").css("padding-top").replace("px", ""));
                n ? s = o.offset().top - e(window).scrollTop() + e("#quick-buy-modal").scrollTop() : (s = o.offset().top - r + 1, (_.bar.hasOpaqueSetting() && _.bar.hasStickySetting() || $ && _.bar.hasStickySetting() || t.data("column-count") > 1 && e(window).outerWidth() >= 1100) && (s -= _.bar.heightExcludingAnnouncementBar()), s < e(window).scrollTop() && "peek" === _.bar.getPositionSetting() && _.bar.hasOpaqueSetting() && (s -= _.bar.heightExcludingAnnouncementBar()), s = s < 200 ? 0 : s), 1 === t.data("column-count") && e(window).outerWidth() >= 1100 && n && (s -= $ ? 60 : -1), n ? e("#quick-buy-modal").animate({
                    scrollTop: s
                }, 800) : e("html,body").animate({
                    scrollTop: s
                }, 800)
            }
        }, theme.viewport.isSm() && 2 === t.data("column-count") && setTimeout(T, 0), t.find(".product-media").each(function (t) {
            c.showMedia(e(this), !1, !0)
        });
        var x = u.find('[data-media-type="external_video"]');

        function L(a) {
            a.preventDefault();
            var o = e(this).closest("[data-media-thumb-id]").data("media-thumb-id");
            return t.find('.product-media[data-media-id="'.concat(o, '"]')).length && (t.closest(".product-area").find(".thumb-active").removeClass("thumb-active"), e(this).addClass("thumb-active"), setTimeout(() => {
                c.scrollToMedia(o)
            }, 0)), !1
        }

        function E() {
            if (theme.Nav(), theme.viewport.isSm()) {
                var t = e(this).find(".rimage-wrapper > img")[0].currentSrc,
                    a = e(this).closest(".theme-images").find("[data-full-size]:visible"),
                    o = '<a href="#" data-modal-close class="modal-close">&times;</a>';
                a.each(function () {
                    var a = e(this).find(".rimage-wrapper > img")[0].currentSrc,
                        n = e(this).data("full-size");
                    o += '<img class="zoom-image" '.concat(t === a ? "id='zoom-image'" : "", ' src="').concat(a, '" data-full-size="').concat(n, '"/>')
                }), showThemeModal(e('<div class="theme-modal theme-modal--fullscreen temp -light"  role="dialog" aria-modal="true"/>').append("\n           <div class='inner-scroller -out'>".concat(o, "</div>")), "product-image", function (t) {
                    var a = e("#zoom-image");
                    a.attr("src", a.data("full-size")), setTimeout(() => {
                        t.find("[data-full-size]").each(function () {
                            e(this).attr("src", e(this).data("full-size"))
                        })
                    }, 100), setTimeout(() => {
                        t.scrollTop(a.position().top + (a.outerHeight() / 2 - t.outerHeight() / 2)), t.find(".inner-scroller").removeClass("-out")
                    }, 1e3)
                })
            }
        }

        function I() {
            e(".carousel-wrapper .carousel:not(.slick-initialized)", b).each(function (t) {
                e(this).on("init reInit setPosition", function () {
                    var t = e(this).find(".slick-slide:last");
                    if (t.length > 0) {
                        var a = t.position().left + t.outerWidth(!0);
                        e(this).parent().outerWidth(!0) > a ? e(this).find(".slick-next, .slick-prev").addClass("theme-unnecessary").attr("tabindex", "-1") : e(this).find(".slick-next, .slick-prev").removeClass("theme-unnecessary").attr("tabindex", "0")
                    }
                }).on("init reInit setPosition", function (t) {
                    e(".lazyload--manual", this).removeClass("lazyload--manual").addClass("lazyload"), setTimeout(function () {
                        e(t.target).find(".slick-slide a").attr("tabindex", "0")
                    })
                }).slick({
                    autoplay: !1,
                    fade: !1,
                    infinite: !1,
                    useTransform: !0,
                    arrows: !0,
                    dots: !1,
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    centerMode: !1,
                    verticalSwiping: !0,
                    vertical: !0,
                    prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronDown + "</button>",
                    nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronDown + "</button>",
                    responsive: [{
                        breakpoint: 1100,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    }, {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4
                        }
                    }]
                })
            }), theme.viewport.isMd() && (c.adjustGalleryMargin = () => {
                t.css("margin-top", "-".concat(b.outerHeight(), "px"))
            }, c.adjustGalleryMargin(), e(window).on("resize.thumbHeight", c.adjustGalleryMargin), e(window).on("debouncedresizewidth.thumbHeight", c.adjustGalleryMargin))
        }

        function M() {
            e(".slick-slider", b).slick("slickFilter", '[data-cc-hidden="false"]')
        }

        function A() {
            var e = t[0].querySelectorAll('.theme-img:not([aria-hidden="true"])'),
                a = t.find(".swiper-container:first").attr("data-swiper-id");
            if (a) {
                var o = theme.swipers[a];
                o && o.params && (o.params.breakpoints[1e4].slidesPerView = e.length < 2 ? 1 : 2, t.attr("data-media-count", e.length), o.currentBreakpoint = !1, o.update())
            }
        }
        t.hasClass("theme-gallery--thumbs-enabled") && t.closest(".product-area").on("click", ".product-area__thumbs__thumb a", L), t.hasClass("theme-gallery--zoom-enabled") && t.on("click", "[data-full-size]", E), e(window).off("ccScrollToMedia.productTemplateGallery".concat(s)).on("ccScrollToMedia.productTemplateGallery".concat(s), function (e, a) {
            (!1 !== t.data("scroll-to-variant-media") || theme.viewport.isXs()) && setTimeout(() => {
                c.scrollToMedia(a)
            }, 0)
        }), y ? x.each(function () {
            e(this).width(t.outerHeight() * e(this).data("aspectratio"))
        }) : (e(C), e(window).on("scroll.productTemplateGallery".concat(s), C)), w && function a() {
            var o = theme.OptionManager.getProductData(null, t.data("product-id"));
            if (o.media && o.media.length > 1 && o.variants && o.variants.length > 1 && o.options && o.options.length > 0) {
                var n = function e(a) {
                    a = a.map(e => e.toLowerCase());
                    var o = t.data("variant-image-grouping-option").split(",");
                    for (var n of o) {
                        var s = a.indexOf(n.trim());
                        if (s > -1) return s
                    }
                    return -1
                }(o.options);
                if (n > -1) {
                    var s, r = [];
                    o.variants.forEach(e => {
                        e.featured_media && (r[e.featured_media.id] || (r[e.featured_media.id] = []), r[e.featured_media.id].push(e.options[n]))
                    });
                    var l = t[0].querySelector(".theme-images"),
                        c = t[0].querySelectorAll(".theme-img");
                    t.on("variantImageSelected", (a, d) => {
                        var h, u = d.options[n],
                            p = !1;
                        s != u && ((y || theme.viewport.isXs()) && (l.innerHTML = "", l.append(...c)), b.length && e(".slick-slider", b).slick("slickUnfilter"), o.media.forEach(e => {
                            r[e.id] && (h = r[e.id]);
                            var a = t[0].querySelector('[data-media-id="'.concat(e.id, '"]'));
                            if (a) {
                                var o = !!(h && h.includes(u));
                                if (a.parentElement.getAttribute("aria-hidden") == o.toString() && (p = !0), h || a.parentElement.remove(), a.parentElement.setAttribute("aria-hidden", !o), y || theme.viewport.isXs()) {
                                    if (o) {
                                        var n = a.querySelector(".lazyload--manual");
                                        n && (n.classList.remove("lazyload--manual"), n.classList.add("lazyload"))
                                    } else a.parentElement.remove()
                                }
                                if (b.length) {
                                    var s = b[0].querySelector('[data-media-thumb-id="'.concat(e.id, '"]'));
                                    s && s.setAttribute("data-cc-hidden", !o)
                                }
                            }
                        }), y && p && A(), theme.viewport.isSm() && 2 === t.data("column-count") && !v && p && setTimeout(() => {
                            k(), T()
                        }, 0), b.length && setTimeout(M, 0), v = !1, s = u)
                    })
                }
            }
        }();
        var P = [];

        function q() {
            k();
            var a = {};
            a = "dots" === u.data("swiper-nav-style") ? {
                dynamicBullets: !0,
                pagination: {
                    el: u.find(".swiper-pagination")[0],
                    dynamicBullets: !0
                }
            } : {
                navigation: {
                    nextEl: u.find(".swiper-button-next")[0],
                    prevEl: u.find(".swiper-button-prev")[0]
                }
            };
            var n = _objectSpread(_objectSpread({
                mode: "horizontal",
                loop: !1,
                resizeReInit: !0,
                autoHeight: !1,
                scrollContainer: !0,
                grabCursor: !0,
                createPagination: !1,
                preventClicks: !1,
                freeMode: !1,
                freeModeFluid: !1,
                slidesPerView: g > 1 ? 2 : 1,
                spaceBetween: y && $ || o ? 20 : 0,
                dynamicBullets: !1,
                mousewheel: {
                    invert: !0,
                    forceToAxis: !0
                },
                scrollbar: {
                    el: u.find(".swiper-scrollbar")[0],
                    draggable: !0
                }
            }, a), {}, {
                breakpoints: {
                    767: _objectSpread({
                        autoHeight: !0,
                        slidesPerView: 1,
                        spaceBetween: 0,
                        freeMode: !1,
                        freeModeFluid: !1
                    }, a),
                    1199: {
                        slidesPerView: 1
                    },
                    1e4: {
                        slidesPerView: g > 1 ? 2 : 1
                    }
                },
                on: {
                    init: function t() {
                        lazySizes.autoSizer.checkElems(), u.find(".swiper-slide-active .lazyload--manual").removeClass("lazyload--manual").addClass("lazyload");
                        var a = 500;
                        theme.viewport.isXs() && (a = null === p.get("is_first_visit") ? 6e3 : 2e3), setTimeout(function () {
                            u.find(".lazyload--manual").removeClass("lazyload--manual").addClass("lazyload")
                        }, a), theme.viewport.isXs() && e(".product-detail__form__options a:not(.size-chart-link)").length && !y && (e(".product-detail__form__options a:not(.size-chart-link):first").focus(), setTimeout(() => {
                            e(window).scrollTop(0)
                        }, 500)), theme.viewport.isXs() && /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && (setTimeout(function () {
                            u.find(".swiper-wrapper").css("display", "inline-flex").css("vertical-align", "bottom")
                        }, 500), setTimeout(function () {
                            u.find(".swiper-wrapper").css("display", "").css("vertical-align", "")
                        }, 1e3))
                    },
                    slideChangeTransitionStart: function e() {
                        u.find(".swiper-slide-active .lazyload--manual").removeClass("lazyload--manual").addClass("lazyload")
                    },
                    slideChangeTransitionEnd: function e(a) {
                        if (c.pauseAllMedia(), theme.viewport.isXs() || y) {
                            var o = t.find(".swiper-slide-active .product-media"),
                                n = d[o.data("media-id")];
                            n && ("model" === o.data("media-type") ? n.updateViewInSpaceButton() : window.ShopifyXR && h.length && (h.attr("data-shopify-model3d-id", h.data("shopify-model3d-first-id")), h.attr("data-shopify-title", h.data("shopify-first-title")), window.ShopifyXR.setupXRElements()))
                        }
                        c.slideshowTabFix()
                    }
                }
            });
            l = new Swiper(u, n);
            var s = new Date().getTime();
            theme.swipers[s] = l, u.attr("data-swiper-id", s);
            var r = t.find(".current-img").index();
            l.slideTo(r, 0), y && (S && t.find(".current-img .product-media").addClass("product-media--active-variant"), w && A()), t.hasClass("featured-product__gallery--single") && u.addClass("swiper-no-swiping"), setTimeout(function () {
                e(window).trigger("resize"), lazySizes.autoSizer.checkElems(), l && l.update(), theme.viewport.isSm() && !y && c.showMedia(u.find(".swiper-slide.swiper-slide-active .product-media"), !1, !0), y && c.slideshowTabFix()
            }, y ? 3e3 : 1e3)
        }

        function z() {
            u.removeClass("swiper-no-swiping"), l && l.destroy(!0), T(), b.length && theme.viewport.isMd() && I()
        }
        t.on("variantImageSelected", function (a, o) {
            c.pauseAllMedia();
            var n = e(this),
                s = n.closest("[data-section-id]").data("section-id");
            if (e(this).find(".swiper-container-horizontal").length) {
                var r = e(".swiper-container:first", this).attr("data-swiper-id"),
                    l = theme.swipers[r],
                    d = this;
                setTimeout(function () {
                    var t, a = 0;
                    e('.swiper-container:first .swiper-slide:not([aria-hidden="true"]) .product-media', d).each(function (n) {
                        e(this).data("media-id") == o.featured_media.id && (a = n, t = e(this))
                    }), l.update(), l.slideTo(a, theme.viewport.isXs() ? 500 : 800), S && (n.find(".product-media--active-variant").removeClass("product-media--active-variant"), t && t.closest(".product-media").addClass("product-media--active-variant"))
                }, "firstrun" === o.eventType ? 1500 : 0)
            } else !e(this).hasClass("featured-product__gallery") && ((0 === n.closest(".shopify-section").index() || P.includes(s)) && e(window).trigger("ccScrollToMedia", o.featured_media.id), P.push(s), t.data("column-count") > 1 && S && (t.find(".product-media--active-variant").removeClass("product-media--active-variant"), t.find('[data-media-id="'.concat(o.featured_media.id, '"]')).addClass("product-media--active-variant")));
            setTimeout(() => {
                var t = e('[data-section-id="'.concat(s, '"] .product-area__thumbs .carousel.slick-initialized'));
                if (1 === t.length && (!1 !== n.data("scroll-to-variant-media") || theme.viewport.isXs())) {
                    var a = t.find('[data-media-thumb-id="'.concat(o.featured_media.id, '"]:first'));
                    a.length && (t.find(".thumb-active").removeClass("thumb-active"), a.find("a").addClass("thumb-active"), t.slick("slickGoTo", a.data("slick-index")))
                }
            }, 0)
        });
        var B = !1;

        function D() {
            theme.viewport.isXs() && !B ? (B = !0, q()) : theme.viewport.isSm() && B ? (B = !1, z(), u.find(".lazyload--manual").removeClass("lazyload--manual").addClass("lazyload")) : theme.viewport.isSm() && u.find(".lazyload--manual").removeClass("lazyload--manual").addClass("lazyload")
        }
        e(function () {
            y ? (q(), e(window).on("cc-mobile-viewport-size-change.swiper", () => {
                z(), q()
            })) : (D(), e(window).on("debouncedresize.swiper", D)), b.length && theme.viewport.isMd() && I()
        })
    }, theme.initContentSlider = function (t, a) {
        e(".slideshow", t).each(function () {
            var t = 1e3 * e(this).data("autoplay-speed"),
                o = "instant" == e(this).data("transition") ? 0 : 600;
            e(this).on("init", function () {
                e(".slick-current .lazyload--manual", this).removeClass("lazyload--manual").addClass("lazyload"), e(function () {
                    setTimeout(() => {
                        e(".lazyload--manual", this).removeClass("lazyload--manual").addClass("lazyload")
                    }, null === p.get("is_first_visit") ? 5e3 : 2e3)
                })
            }).slick({
                autoplay: e(this).data("autoplay"),
                fade: !("slide" === e(this).data("transition") && theme.viewport.isXs()),
                speed: o,
                autoplaySpeed: t,
                arrows: "arrows" == e(this).data("navigation"),
                dots: "dots" == e(this).data("navigation"),
                infinite: !0,
                useTransform: !0,
                prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
                nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
                pauseOnHover: !1,
                cssEase: "cubic-bezier(0.25, 1, 0.5, 1)",
                lazyLoad: e(this).find("[data-lazy]").length > 0 ? "ondemand" : null,
                customPaging: function e(a, n) {
                    return '<button class="custom-dot" type="button" data-role="none" role="button" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" xml:space="preserve"><circle class="circle-one" cx="15" cy="15" r="13" />' + '<circle class="circle-two" cx="15" cy="15" r="13" style="animation-duration: '.concat(t + o, 'ms" />') + "</svg></button>"
                },
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        arrows: !1,
                        dots: "none" != e(this).data("navigation"),
                        lazyLoad: e(this).find("[data-lazy]").length > 0 ? "progressive" : null
                    }
                }]
            }).on("beforeChange", function (t, a, o, n) {
                e(a.$slides).filter(".slick--out").removeClass("slick--out");
                var s = e(a.$slides.get(n)).find(".lazyload--manual");
                s.length && s.removeClass("lazyload--manual").addClass("lazyload"), ("slide" === e(this).data("transition") || "zoom" === e(this).data("transition")) && e(a.$slides.get(o)).addClass("slick--leaving")
            }).on("afterChange", function (t, o, n) {
                e(o.$slides).filter(".slick--leaving").addClass("slick--out").removeClass("slick--leaving"), a && a(n)
            })
        })
    }, theme.initProductSlider = function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            a = e.data("products-in-view"),
            o = {
                767: {
                    slidesPerView: 1.2,
                    spaceBetween: 10
                },
                900: {
                    slidesPerView: 4 === a || 3 === a ? 2 : a
                },
                1439: {
                    slidesPerView: 4 === a || 3 === a ? 3 : a
                },
                3e3: {
                    slidesPerView: a,
                    spaceBetween: 20
                }
            };
        t && (o = e.data("first-post-big") ? {
            767: {
                slidesPerView: 1.2,
                spaceBetween: 10
            },
            1024: {
                slidesPerView: "auto"
            },
            1600: {
                slidesPerView: "auto"
            },
            3e3: {
                slidesPerView: "auto",
                spaceBetween: 20
            }
        } : {
            767: {
                slidesPerView: 1.2,
                spaceBetween: 10
            },
            1024: {
                slidesPerView: 2
            },
            1600: {
                slidesPerView: 3
            },
            3e3: {
                slidesPerView: 4,
                spaceBetween: 20
            }
        }), new Swiper(e, {
            mode: "horizontal",
            loop: !1,
            resizeReInit: !0,
            freeMode: !0,
            freeModeFluid: !0,
            scrollContainer: !0,
            grabCursor: !0,
            createPagination: !1,
            slidesPerView: a,
            spaceBetween: 20,
            mousewheel: {
                invert: !0,
                forceToAxis: !0
            },
            scrollbar: {
                el: e.find(".swiper-scrollbar")[0],
                draggable: !0
            },
            navigation: {
                nextEl: e.find(".js-swiper-button-next")[0],
                prevEl: e.find(".js-swiper-button-prev")[0]
            },
            breakpoints: o,
            on: {
                init: function e() {
                    lazySizes.autoSizer.checkElems()
                }
            }
        })
    }, theme.convertOptionsToBoxes = function (t) {
        var a = e(t).find("select[data-make-box]").each(function () {
            e(this).find('option[value=""]').remove()
        }).clickyBoxes().parent().addClass("has-clickyboxes");
        if (e(".selector-wrapper:not(.cc-swatches) .clickyboxes").ccHoverLine({
                lineCss: {
                    height: "2px"
                }
            }), a.length > 0)
            for (var o = theme.OptionManager.getProductData(e(t)), n = 0; n < o.options.length; n++) {
                for (var s = {}, r = 0; r < o.variants.length; r++) {
                    var l = o.variants[r];
                    void 0 === s[l.options[n]] && (s[l.options[n]] = !1), l.available && (s[l.options[n]] = !0)
                }
                for (var c in s) s[c] || e(".selector-wrapper:eq(" + n + ") .clickyboxes li a", t).filter(function () {
                    return e(this).attr("data-value") == c
                }).addClass("unavailable")
            }
    }, theme.loadInfiniteScroll = function (t, a) {
        var o = 1;
        e("[data-infinite-scroll-container] .pagination.infiniscroll:not(.infinit)", t).addClass("infinit").each(function () {
            var n = e(this).hasClass("wait-for-trigger"),
                s = e('<div class="pager-button"><a href="#" aria-label="' + theme.strings.loadMore + '">' + theme.icons.loading + "</a></div>");
            e(this).replaceWith(s), s.find("a").attr("href", e(this).find(".next a").attr("href")), s.on("click", "a", function (n) {
                if (e(this).hasClass("loading")) return !1;
                e(this).addClass("loading");
                var r = e(this);
                return e.get(e(this).attr("href"), function (n) {
                    o++;
                    var l = !1,
                        c = e(e.parseHTML(n));
                    if (e("[data-infinite-scroll-results].product-list--columns", t).length) {
                        l = !0;
                        var d = c.find("[data-infinite-scroll-results]").hide();
                        d.prepend("<h2>" + theme.strings.page.replace("{{ page }}", o) + "</h2>");
                        var d = d.insertBefore("[data-infinite-scroll-container] .pager-button");
                        console.log('loading1');
                    } else var d = c.find("[data-infinite-scroll-results] .product-block").hide().appendTo("[data-infinite-scroll-results]");
                    if (e("[data-infinite-scroll-container]", t).filter(".product-block").each(function (t) {
                            e(this).removeAttr("data-loop-index").data("loop-index", t), i++
                        }), l) setTimeout(function () {
                        d.fadeIn(), theme.inlineVideos.init(t), theme.initAnimateOnScroll(), lazySizes.autoSizer.checkElems(), a && a();
                        console.log('loading2');
                    }, 300);
                    else {
                        e("[data-infinite-scroll-results]", t).height(e("[data-infinite-scroll-results]", t).height()), d.addClass("pre-trans").css("display", "");
                        var h = 0;
                        e("[data-infinite-scroll-results]", t).children().each(function () {
                            var t = e(this).position().top + e(this).height();
                            t > h && (h = t)
                        }), e("[data-infinite-scroll-results]", t).animate({
                            height: h
                        }, 500, function () {
                            e(this).css("height", ""), d.removeClass("pre-trans"), theme.inlineVideos.init(t), theme.initAnimateOnScroll(), new v, lazySizes.autoSizer.checkElems(), a && a()
                        })
                        console.log('loading3');
                    }
                    var u = c.find("[data-infinite-scroll-container] .pagination .next a");
                    0 == u.length ? s.slideUp() : r.attr("href", u.attr("href")).removeClass("loading");
                    if(document.querySelector('.trade-customer')) {
                        function changeVAT(vat) {
                            var incVat = document.getElementsByClassName('price__current--inc');
                            var exVat = document.getElementsByClassName('price__current--ex');

                            if(vat == 'ex') {
                                localStorage.setItem('vat', 'inc');
                                for(const ex of exVat) {
                                    ex.classList.remove('hidden');
                                }

                                for(const inc of incVat) {
                                    inc.classList.add('hidden');
                                }
                            } else {
                                localStorage.setItem('vat', 'inc');

                                for(const ex of exVat) {
                                    ex.classList.add('hidden');
                                }

                                for(const inc of incVat) {
                                    inc.classList.remove('hidden');
                                }
                            }
                        }

                        setTimeout(() => {
                            changeVAT(localStorage.getItem('vat')); 
                        }, 200);
                    }
                }), !1
                
            }), n || e(window).on("throttled-scroll.infiniscroll", function () {
                e(window).scrollTop() + e(window).height() > s.offset().top - 500 && s.find("a").trigger("click")
            })
        })
    }, theme.unloadInfiniteScroll = function (t) {
        t && e(".pagination.infiniscroll.infinit", t).removeClass("infinit"), e(window).off("throttled-scroll.infiniscroll")
    }, theme.applyAjaxToProductForm = function (t) {
        var a = theme.routes.cart_add_url + ".js";
        t.filter('[data-ajax-add-to-cart="true"]:not(.feedback-go_to_cart)').find(".product-purchase-form").on("submit", function (t) {
            t.preventDefault();
            var o = e(this),
                n = e(this).find("[type=submit]").attr("disabled", "disabled").addClass("confirmation adding");
            n.data("originalHtml", n.html()).html(theme.strings.productAddingToCart);
            var s = e(".product-area__add-to-cart-xs button"),
                r = theme.viewport.isXs() && s.length;
            r && (s.attr("disabled", "disabled"), s.data("originalHtml", s.html()).html(theme.strings.productAddingToCart)), e.post(a, o.serialize(), function (t) {
                if (n.html(theme.icons.tick + " " + theme.strings.productAddedToCart), r && s.html(theme.icons.tick + " " + theme.strings.productAddedToCart), setTimeout(function () {
                        n.removeAttr("disabled").removeClass("confirmation").html(n.data("originalHtml")), r && s.removeAttr("disabled").removeClass("confirmation").html(s.data("originalHtml"))
                    }, 4e3), o.hasClass("feedback-add_in_modal") || o.hasClass("feedback-add_in_modal_no_checkout")) {
                    var a = e.parseJSON(t),
                        l = o.hasClass("feedback-add_in_modal_no_checkout"),
                        c = theme.Shopify.formatImage(a.image, "300x");
                    new Image().src = c, n.removeClass("adding");
                    var d = "",
                        h = o.closest(".product-area__details__inner").find(".price-area");
                    if (h.length && (d += '<p class="cart-product__content__price">'.concat(h.html(), "</p>")), a.selling_plan_allocation && a.selling_plan_allocation.selling_plan.name && (d += '<p class="cart-product__content__meta">'.concat(a.selling_plan_allocation.selling_plan.name, "</p>")), a.options_with_values && a.options_with_values.length)
                        for (var u = 0; u < a.options_with_values.length; u++) {
                            var p = a.options_with_values[u];
                            "Title" !== p.name && "Default Title" !== p.value && (d += '<p class="cart-product__content__meta">'.concat(p.name, ": ").concat(p.value, "</p>"))
                        }
                    var f = 25,
                        m = theme.Nav();
                    "inline" !== m.bar.getPositionSetting() && (f = m.bar.height()), showThemeModal(['<div id="added-to-cart" class="theme-modal theme-modal--small" role="dialog" aria-modal="true" aria-labelledby="added-to-cart-title">', '<div class="inner" style="top:'.concat(f, 'px">'), '<a href="#" data-modal-close class="modal-close">&times;</a>', '<h4 id="added-to-cart-title">' + theme.icons.tick + theme.strings.productAddedToCart + "</h4>", '<div class="cart-product">', '<div class="cart-product__image"><img src="'.concat(c, '" alt="').concat(a.featured_image.alt, '"/></div>'), '<div class="cart-product__content"><p class="cart-product__content__title">', a.product_title, "</p>" + "".concat(d || "") + "</div>", "</div>", '<p class="links '.concat(l ? "links--no-checkout" : "", '">'), '<a href="' + theme.routes.cart_url + '" class="button '.concat(l ? "" : "alt", '">') + theme.strings.viewCart + "</a>", '<a href="' + theme.routes.checkout + '" class="button button--checkout" [data-cc-checkout-button]>' + theme.strings.popupCheckout + "</a> ", "</p>", "</div>", "</div>"].join(""), "added-to-cart", null)
                }
                e.get(theme.routes.cart_url, function (t) {
                    var a = '#site-control .cart:not(.nav-search), [data-section-type="cart-template"]',
                        o = e(e.parseHTML("<div>" + t + "</div>")).find(a);
                    e(a).each(function (t) {
                        e(o[t]).find("[data-cc-animate]").removeAttr("data-cc-animate"), e(this).replaceWith(o[t]), e(this).parent().find("[data-cc-animate]").removeAttr("data-cc-animate")
                    })
                })
            }, "text").fail(function (t) {
                if (n.removeAttr("disabled").removeClass("confirmation").html(n.data("originalHtml")), r && s.removeAttr("disabled").removeClass("confirmation").html(s.data("originalHtml")), void 0 !== t && void 0 !== t.status) {
                    var a = e.parseJSON(t.responseText),
                        l = o.find(".product-status-message");
                    l.html(a.description), l.slideDown().fadeIn(), setTimeout(() => {
                        l.slideUp()
                    }, 8e3)
                } else o.attr("ajax-add-to-cart", "false").submit()
            })
        })
    }, theme.removeAjaxFromProductForm = function (e) {
        e.find("form.product-purchase-form").off("submit")
    }, theme.OptionManager = new function () {
        var t = this;
        t._getVariantOptionElement = function (e, t) {
            return t.find('select[name="id"] option[value="' + e.id + '"]')
        }, t.selectors = {
            container: ".product-area",
            gallery: ".theme-gallery",
            priceArea: ".price-area",
            variantIdInputs: '[name="id"]',
            submitButton: ".product-purchase-form [type=submit], .product-area__add-to-cart-xs button",
            multiOption: ".option-selectors"
        }, t.strings = {
            priceNonExistent: theme.strings.priceNonExistent,
            buttonDefault: theme.strings.buttonDefault,
            buttonPreorder: theme.strings.buttonPreorder,
            buttonNoStock: theme.strings.buttonNoStock,
            buttonNoVariant: theme.strings.buttonNoVariant,
            unitPriceSeparator: theme.strings.unitPriceSeparator,
            inventoryNotice: theme.strings.onlyXLeft,
            inventoryLowStock: theme.strings.inventoryLowStock,
            inventoryInStock: theme.strings.inventoryInStock,
            priceSoldOut: theme.strings.priceSoldOut
        }, t._getString = function (e, a) {
            var o = t.strings[e];
            return a && (o ? o = o.replace("[PRICE]", '<span class="theme-money">' + theme.Shopify.formatMoney(a.price, theme.money_format_with_code_preference) + "</span>") : console.warn("No string for key '".concat(e, "' was found."))), o
        }, t.getProductData = function (e, t) {
            t || (t = e.data("product-id"));
            var a = null;
            return theme.productData[t] || (theme.productData[t] = JSON.parse(document.getElementById("cc-product-json-" + t).innerHTML)), (a = theme.productData[t]) || console.log("Product data missing (id: " + e.data("product-id") + ")"), a
        }, t.getBaseUnit = function (e) {
            return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit
        }, t.addVariantUrlToHistory = function (e) {
            if (e) {
                var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                window.history.replaceState({
                    path: t
                }, "", t)
            }
        }, t.updateSku = function (e, t) {
            t.find(".sku .sku__value").html(e ? e.sku : ""), t.find(".sku").toggleClass("sku--no-sku", !e || !e.sku)
        }, t.updateBarcode = function (e, t) {
            t.find(".barcode .barcode__value").html(e ? e.barcode : ""), t.find(".barcode").toggleClass("barcode--no-barcode", !e || !e.barcode)
        }, t.updateInventoryNotice = function (e, a) {
            var o = a.find(".product-inventory-notice"),
                n = a.find(".product-inventory-notice__text"),
                s = a.find(".product-inventory-notice__indicator");
            if (o.length) {
                var r = t._getVariantOptionElement(e, a).data("inventory"),
                    l = o[0].dataset;
                if (c = "always" === l.showInventoryCount || "low" === l.showInventoryCount && r <= l.inventoryThreshold ? t._getString("inventoryNotice").replace("[[ quantity ]]", r) : r <= parseInt(l.inventoryThreshold) ? t._getString("inventoryLowStock") : t._getString("inventoryInStock"), 1 === s.length) {
                    var c, d, h = s.find("span");
                    d = r >= l.indicatorScale ? 100 : (100 / parseInt(l.indicatorScale) * r).toFixed(1), r <= parseInt(l.inventoryThreshold) ? h.css("width", d + "%").css("background-color", l.indicatorScaleColorBelow) : h.css("width", d + "%").css("background-color", l.indicatorScaleColorAbove)
                }
                r && r > 0 && ("always" === l.showInventoryNotice || r <= parseInt(l.inventoryThreshold)) ? (o.removeClass("product-inventory-notice--no-inventory").slideDown(300), n.html(c)) : o.addClass("product-inventory-notice--no-inventory").slideUp(300)
            }
        }, t.updateBackorder = function (e, a) {
            var o = a.find(".backorder");
            if (o.length) {
                if (e && e.available) {
                    if (e.inventory_management && "out" == t._getVariantOptionElement(e, a).data("stock")) {
                        var n = t.getProductData(a);
                        o.find(".backorder__variant").html(n.title + (e.title.indexOf("Default") >= 0 ? "" : " - " + e.title)), o.show()
                    } else o.hide()
                } else o.hide()
            }
        }, t.updatePrice = function (a, o) {
            var n = o.find(t.selectors.priceArea);
            var unitPrice = a.price;
            var comparePrice = a.compare_at_price;
            if(document.querySelector('.trade-customer')) {
                if(localStorage.getItem('vat') == 'ex') {
                    unitPrice = a.price / 1.2;
                    comparePrice = a.compare_at_price / 1.2;
                    if(document.querySelector('.trade-customer-market-ireland')) {
                        unitPrice = a.price / 1.23;
                        comparePrice = a.compare_at_price / 1.23;
                    }
                }
            }
            if (n.removeClass("on-sale"), a) {
                var s = e("<div>");
                if (a.compare_at_price > a.price && (e('<span class="was-price theme-money">').html(theme.Shopify.formatMoney(comparePrice, theme.money_format_with_code_preference)).appendTo(s), s.append(" "), n.addClass("on-sale")), e('<span class="current-price theme-money">').html(theme.Shopify.formatMoney(unitPrice, theme.money_format_with_code_preference)).appendTo(s), a.unit_price_measurement) {
                    var r = e('<div class="unit-price">').appendTo(s);
                    e('<span class="unit-price__price theme-money">').html(theme.Shopify.formatMoney(unitPrice, theme.money_format)).appendTo(r), e('<span class="unit-price__separator">').html(t._getString("unitPriceSeparator")).appendTo(r), e('<span class="unit-price__unit">').html(t.getBaseUnit(a)).appendTo(r)
                }
                n.html(s.html())
            } else n.html('<span class="current-price">'.concat(t.strings.priceNonExistent, "</span>"))
            var selectors = document.getElementsByClassName('vat-selectors');
             for(const selector of selectors) {
                selector.addEventListener('change', function() {
                    var n = o.find(t.selectors.priceArea);
                    var unitPrice = a.price;
                    var comparePrice = a.compare_at_price;
                    if(document.querySelector('.trade-customer')) {
                        if(localStorage.getItem('vat') == 'ex') {
                            unitPrice = a.price / 1.2;
                            comparePrice = a.compare_at_price / 1.2;
                            if(document.querySelector('.trade-customer-market-ireland')) {
                                unitPrice = a.price / 1.23;
                                comparePrice = a.compare_at_price / 1.23;
                            }
                        }
                    }
                    if (n.removeClass("on-sale"), a) {
                        var s = e("<div>");
                        if (a.compare_at_price > a.price && (e('<span class="was-price theme-money">').html(theme.Shopify.formatMoney(comparePrice, theme.money_format_with_code_preference)).appendTo(s), s.append(" "), n.addClass("on-sale")), e('<span class="current-price theme-money">').html(theme.Shopify.formatMoney(unitPrice, theme.money_format_with_code_preference)).appendTo(s), a.unit_price_measurement) {
                            var r = e('<div class="unit-price">').appendTo(s);
                            e('<span class="unit-price__price theme-money">').html(theme.Shopify.formatMoney(unitPrice, theme.money_format)).appendTo(r), e('<span class="unit-price__separator">').html(t._getString("unitPriceSeparator")).appendTo(r), e('<span class="unit-price__unit">').html(t.getBaseUnit(a)).appendTo(r)
                        }
                        n.html(s.html())
                    } else n.html('<span class="current-price">'.concat(t.strings.priceNonExistent, "</span>"))
                });
            }
        }, t._updateButtonText = function (a, o, n) {
            a.each(function () {
                var a;
                !1 !== (a = t._getString("button" + o, n)) && (e(this).is("input") ? e(this).val(a) : e(this).html(a))
            })
        }, t.updateButtons = function (e, a) {
            var o = a.find(t.selectors.submitButton);
            e && !0 == e.available ? (o.removeAttr("disabled"), a.data("is-preorder") ? t._updateButtonText(o, "Preorder", e) : t._updateButtonText(o, "Default", e)) : (o.attr("disabled", "disabled"), e ? t._updateButtonText(o, "NoStock", e) : t._updateButtonText(o, "NoVariant", e))
        }, t.updateContainerStatusClasses = function (e, a) {
            a.toggleClass("variant-status--unavailable", !e.available), a.toggleClass("variant-status--backorder", e.available && e.inventory_management && "out" == t._getVariantOptionElement(e, a).data("stock"))
        }, t.updateVariantOptionStatusClasses = function (a, o) {
            var n = t.getProductData(o);

            function s(e) {
                return n.variants.filter(t => {
                    for (var a = !0, o = 0; o < e.length; o++)
                        if (t.options[o] !== e[o]) {
                            a = !1;
                            break
                        } return a
                })
            }

            function r(e) {
                for (var t = {}, a = 0; a < n.variants.length; a++) {
                    var o = n.variants[a].options[e];
                    o && (t[o] = !1)
                }
                return t
            }
            if (!1 === a && (a = {
                    options: []
                }, o.find(".selector-wrapper a.active[data-value]").each(function () {
                    a.options.push(e(this).data("value"))
                })), a && a.options && a.options.length > 1) {
                for (var l = [...a.options], c = {}, d = a.options.length - 1; d >= 0; d--) {
                    l.pop();
                    for (var h = r(d), u = s(l), p = 0; p < u.length; p++)
                        if (u[p].available) {
                            var f = u[p].options[d];
                            f && (h[f] = !0)
                        } c[n.options[d]] = h
                }
                e(".selector-wrapper", o).each(function () {
                    var t = e(this).data("option-name");
                    for (var [a, o] of Object.entries(c[t])) a = removeDiacritics(a).toLowerCase().replace(/'/g, "").replace(/[^a-z0-9]+/g, "-").replace(/-+/g, "-").replace(/-*$/, ""), e(this).find(".clickyboxes .opt--".concat(a)).toggleClass("unavailable", !o)
                })
            }
        }, t.initProductOptions = function (a) {
            if (!a.hasClass("theme-init")) {
                var o = t.getProductData(a);
                a.addClass("theme-init"), a.find(t.selectors.multiOption).on("change.themeProductOptions", "select", function () {
                    var n = [];
                    e(this).closest(t.selectors.multiOption).find("select").each(function () {
                        n.push(e(this).val())
                    });
                    for (var s = !1, r = 0; r < o.variants.length; r++) {
                        for (var l = o.variants[r], c = 0, d = 0; d < n.length; d++) l.options[d] == n[d] && c++;
                        if (c == n.length) {
                            s = l;
                            break
                        }
                    }
                    s && a.find(t.selectors.variantIdInputs).val(s.id), a.find(t.selectors.variantIdInputs).each(function () {
                        this.dispatchEvent(new CustomEvent("change", {
                            bubbles: !0,
                            cancelable: !1,
                            detail: s
                        }))
                    })
                }), a.find(t.selectors.variantIdInputs).each(function () {
                    e(this).on("change.themeProductOptions firstrun.themeProductOptions", function (n) {
                        if (!e(this).is("input[type=radio]:not(:checked)")) {
                            var s = n.detail;
                            if (!s && !1 !== s)
                                for (var r = 0; r < o.variants.length; r++) o.variants[r].id == e(this).val() && (s = o.variants[r]);
                            var l = e(this).closest(t.selectors.container),
                                c = l.find(t.selectors.submitButton).filter("[data-add-to-cart-text]");
                            c.length && (t.strings.buttonDefault = c.data("add-to-cart-text")), t.updatePrice(s, l), t.updateButtons(s, l), e(window).trigger("cc-variant-updated", {
                                variant: s,
                                product: o
                            }), e(window).trigger("debouncedresizewidth"), s && s.featured_media && l.find(t.selectors.gallery).trigger("variantImageSelected", s), t.updateBarcode(s, l), t.updateSku(s, l), t.updateInventoryNotice(s, l), t.updateBackorder(s, l), t.updateContainerStatusClasses(s, l), a.find('[data-show-realtime-availability="true"]').length > 0 && t.updateVariantOptionStatusClasses(s, a), a.data("enable-history-state") && "change" == n.type && t.addVariantUrlToHistory(s), a.find(".quickbuy-container").trigger("changedsize"), a.trigger("variantChanged", s)
                        }
                    }), e(this).trigger("firstrun")
                }), theme.applyAjaxToProductForm(a)
            }
        }, t.unloadProductOptions = function (a) {
            a.removeClass("theme-init").each(function () {
                e(this).trigger("unloading").off(".themeProductOptions"), e(this).find(t.selectors.multiOption).off(".themeProductOptions"), theme.removeAjaxFromProductForm(a)
            })
        }
    }, theme.addControlPaddingToModal = function () {
        e(".theme-modal.reveal > .inner").css("padding-top", theme.Nav().bar.height())
    }, theme.allowRTEFullWidthImages = function (t) {
        e(".rte--allow-full-width-images p > img, .rte--allow-full-width-images div > img", t).each(function () {
            0 == e(this).siblings().length && e(this).parent().addClass("no-side-pad")
        }), e(".rte--allow-full-width-images p > a > img, .rte--allow-full-width-images div > a > img", t).each(function () {
            0 == e(this).siblings().length && 0 == e(this).parent().siblings().length && e(this).parent().addClass("no-side-pad")
        })
    }, theme.browserHas3DTransforms = function () {
        var e, t = document.createElement("p"),
            a = {
                webkitTransform: "-webkit-transform",
                OTransform: "-o-transform",
                msTransform: "-ms-transform",
                MozTransform: "-moz-transform",
                transform: "transform"
            };
        for (var o in document.body.insertBefore(t, null), a) void 0 !== t.style[o] && (t.style[o] = "translate3d(1px,1px,1px)", e = window.getComputedStyle(t).getPropertyValue(a[o]));
        return document.body.removeChild(t), void 0 !== e && e.length > 0 && "none" !== e
    }, theme.browserHas3DTransforms() && e("html").addClass("supports-transforms"), theme.namespaceFromSection = function (t) {
        return [".", e(t).data("section-type"), e(t).data("section-id")].join("")
    }, theme.inlineVideos = {
        init(t) {
            e(".section-background-video--inline", t).each(function () {
                theme.VideoManager.onSectionLoad(e(this)[0]), e(this).addClass("cc-init")
            })
        },
        destroy(t) {
            e(".section-background-video--inline", t).each(function () {
                theme.VideoManager.onSectionUnload(e(this)[0]), e(this).removeClass("cc-init")
            })
        }
    }, theme.initShopifyPaymentButtons = function (e) {
        if (Shopify.PaymentButton && e.find(".shopify-payment-button").length) {
            var t = null;
            t = function a() {
                document.removeEventListener("shopify:payment_button:loaded", t), e.trigger("changedsize")
            }, document.addEventListener("shopify:payment_button:loaded", t), Shopify.PaymentButton.init()
        }
    }, theme.initComponents = function (t) {
        var a = t.find("[data-components]");
        a.length && a.data("components").split(",").forEach(a => {
            e(document).trigger("cc:component:load", [a, t[0]])
        })
    }, theme.assessFullWidthSections = function () {
        document.querySelectorAll("#page-content .shopify-section > .use-alt-bg").forEach(e => e.parentElement.classList.add("has-alt-bg"))
    }, theme.updateNavHeight = function () {
        var e = theme.Nav();
        document.documentElement.style.setProperty("--nav-height", e.bar.height() + "px"), document.querySelectorAll("[data-cc-sticky-scroll-top]").forEach(t => {
            t.setAttribute("data-cc-sticky-scroll-top", e.bar.height() + 20)
        })
    }, theme.init = function () {
        theme.checkViewportFillers(), theme.assessAltLogo(), theme.assessFullWidthSections(), theme.calc100vh(), theme.updateNavHeight()
    }, theme.windowResize = function () {
        theme.calc100vh(), theme.updateNavHeight()
    }, jQuery(function (e) {
        e(document).on("click", "[data-cc-quick-buy]", function () {
            theme.Nav();
            var t = e(this).attr("href");
            return theme.currentQuickbuyRequest && theme.currentQuickbuyRequest.abort(), showThemeModal('<div class="theme-modal theme-modal--fullscreen theme-modal--quickbuy -light" id="quick-buy-modal" role="dialog" aria-modal="true"/>\n                        <a href="#" data-modal-close class="modal-close">&times;</a>\n                        <div class="theme-modal__loading">'.concat(theme.icons.loading, "</div>\n                    </div>"), "quick-buy", null), theme.currentQuickbuyRequest = e.get(t, function (a) {
                var o = e("#quick-buy-modal"),
                    n = e("<div>" + a + "</div>").find(".section-product-template"),
                    s = n.find('[data-section-type="product-template"]')[0];
                n.find(".store-availability-container-outer").remove(), n.find('[data-show-in-quickbuy="false"]').remove(), n.find(".theme-gallery--zoom-enabled").removeClass("theme-gallery--zoom-enabled"), n.find(".product-area__details__title").wrapInner(e("<a>").attr("href", t).attr("data-cc-animate-click", "true")), n.find(".product-detail__more_details a").attr("href", t), o.find(".theme-modal__loading").replaceWith(n), theme.initAnimateOnScroll(), theme.ProductTemplateSection.onSectionLoad(s, !0), theme.initComponents(o), theme.initShopifyPaymentButtons(o), e(window).one("ccModalClosing", function () {
                    theme.ProductTemplateSection.onSectionUnload(s, !0)
                })
            }).always(function () {
                theme.currentQuickbuyRequest = !1
            }), !1
        })
    });
    class m {
        constructor(e) {
            this.productBlock = e, this.productBlockImageContainer = this.productBlock.querySelector(".image"), this.imageContainer = this.productBlock.querySelector(".image-inner"), this.swatchesContainer = this.productBlock.querySelector(".cc-swatches"), this.slideDuration = 1e3, this.swatchImagesPreloaded = !1, this.imageSliderLoaded = !1, this.widths = [460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048], this.imageWidth, this.hoverTimeout, this.preloadedImages = [], this.swatches = [], this.bindEvents(), this.productBlock.querySelector('[data-section-type="background-video"]') && this.initImageSlider()
        }
        showNextSlideImage() {
            this.hoverTimeout = setTimeout(() => {
                var e = this.imageContainer.querySelectorAll(".product-block--slide");
                if (e && e.length > 1) {
                    if (this.imageContainer.querySelector(".product-block--slide.-in")) {
                        for (var t = 0; t < e.length; t++)
                            if (e[t].classList.contains("-in")) {
                                e[t].classList.remove("-in"), t === e.length - 1 ? (this.destroyImageSliderLoadingBar(), e[0].classList.add("-in"), this.initImageSliderLoadingBar()) : e[t + 1].classList.add("-in");
                                break
                            }
                    } else this.imageContainer.querySelector(".image__first").classList.add("-out"), e[1].classList.add("-in")
                }
                this.showNextSlideImage()
            }, this.slideDuration)
        }
        showSpecificSlideImage(e) {
            var t = e.substring(0, e.lastIndexOf("_")),
                a = this.imageContainer.querySelector('.product-block--slide[src^="'.concat(t, '"]'));
            if (a) {
                var o = this.imageContainer.querySelector(".product-block--slide.-in");
                o && o.classList.remove("-in"), this.imageContainer.querySelector(".image__first").classList.add("-out"), a.classList.add("-in")
            } else console.warn("No next slide for ", t)
        }
        preloadImage(e) {
            !this.preloadedImages.includes(e) && (new Image().src = e, this.preloadedImages.push(e))
        }
        getImageUrl(e) {
            for (var t = theme.device.isRetinaDisplay() ? 2 * this.productBlock.clientWidth : this.productBlock.clientWidth, a = 0; a < this.widths.length; a++)
                if (this.widths[a] >= t) return this.imageWidth = this.widths[a], e.replace("{width}", this.widths[a])
        }
        initImageSlider() {
            if (this.productBlock) {
                var e = this.productBlock.dataset.productImages;
                if (e && !this.imageSliderLoaded) {
                    var t = e.split(","),
                        a = "";
                    t.forEach(e => {
                        a += '<img class="product-block--slide" tabindex="-1" src="'.concat(this.getImageUrl(e), '"/>')
                    }), this.imageContainer.innerHTML += a, this.imageSliderLoaded = !0
                }
            }
        }
        destroyImageSlider() {
            if (this.imageSliderLoaded) {
                var e = this.imageContainer.querySelectorAll(".product-block--slide");
                e && e.forEach(e => {
                    e.remove()
                }), this.imageSliderLoaded = !1
            }
        }
        handleMouseEnterSwatch(e) {
            if (e.target.dataset.variantImage) {
                this.imageSliderLoaded || this.initImageSlider();
                var t = this.getImageUrl(e.target.dataset.variantImage);
                this.showSpecificSlideImage(t)
            }
        }
        handleMouseLeaveSwatch(e) {
            var t = this.imageContainer.querySelector(".product-block--slide.-in");
            t && t.classList.remove("-in"), this.imageContainer.querySelector(".image__first").classList.remove("-out")
        }
        handleClickSwatch(e) {
            e.preventDefault()
        }
        handleMouseEnterProductBlock(e) {
            this.swatchImagesPreloaded || (this.productBlock.querySelectorAll(".cc-swatches a").forEach(e => {
                e.dataset.variantImage && this.preloadImage(this.getImageUrl(e.dataset.variantImage))
            }), this.swatchImagesPreloaded = !0), this.productBlock.dataset.productImages && !this.imageSliderLoaded && (this.productBlock.classList.contains("all-images") ? this.initImageSlider() : setTimeout(this.initImageSlider, 500))
        }
        handleEnterImageContainer(e) {
            this.productBlock.classList.contains("all-images") && (this.showNextSlideImage(), this.initImageSliderLoadingBar())
        }
        handleLeaveImageContainer(e) {
            if (clearTimeout(this.hoverTimeout), this.imageSliderLoaded) {
                var t = this.imageContainer.querySelector(".product-block--slide.-in");
                t && (t.classList.remove("-in"), this.imageContainer.querySelector(".image__first").classList.remove("-out")), this.destroyImageSliderLoadingBar()
            }
        }
        initImageSliderLoadingBar() {
            var e = this.imageContainer.querySelectorAll(".product-block--slide").length * this.slideDuration - 100,
                t = document.createElement("div");
            t.classList.add("loading-bar"), t.style.transitionDuration = e + "ms", this.productBlockImageContainer.append(t), setTimeout(() => {
                t.classList.add("-in")
            }, 100)
        }
        destroyImageSliderLoadingBar() {
            var e = this.productBlockImageContainer.querySelector(".loading-bar");
            e && e.remove()
        }
        handleWindowResize() {
            if (this.imageWidth && this.productBlock.clientWidth > this.imageWidth) {
                for (var e = 0; e < this.widths.length; e++)
                    if (this.widths[e] >= this.productBlock.clientWidth && this.widths[e] > this.imageWidth) {
                        this.destroyImageSlider();
                        break
                    }
            }
        }
        bindEvents() {
            this.focusSwatchHandler = this.handleMouseEnterSwatch.bind(this), this.mouseEnterSwatchHandler = theme.debounce(this.handleMouseEnterSwatch.bind(this), 150), this.mouseLeaveSwatchHandler = theme.debounce(this.handleMouseLeaveSwatch.bind(this), 150), this.touchDeviceClickHandler = this.handleClickSwatch.bind(this), this.mouseEnterProductBlockHandler = this.handleMouseEnterProductBlock.bind(this), this.mouseEnterImageContainerHandler = this.handleEnterImageContainer.bind(this), this.mouseLeaveImageContainerHandler = this.handleLeaveImageContainer.bind(this), this.windowResizeHandler = theme.debounce(this.handleWindowResize.bind(this)), this.productBlock.querySelectorAll(".cc-swatches a").forEach(e => {
                e.addEventListener("mouseenter", this.mouseEnterSwatchHandler), e.addEventListener("focus", this.focusSwatchHandler), this.swatches.push(e), theme.device.isTouch() && e.addEventListener("click", this.touchDeviceClickHandler)
            }), this.swatchesContainer && this.swatchesContainer.addEventListener("mouseleave", this.mouseLeaveSwatchHandler), this.productBlock.addEventListener("mouseenter", this.mouseEnterProductBlockHandler), this.imageContainer.addEventListener("mouseenter", this.mouseEnterImageContainerHandler), this.imageContainer.addEventListener("mouseleave", this.mouseLeaveImageContainerHandler), window.addEventListener("resize", this.windowResizeHandler)
        }
        destroy() {
            this.swatches.forEach(e => {
                e.removeEventListener("mouseenter", this.mouseEnterSwatchHandler), e.removeEventListener("click", this.touchDeviceClickHandler)
            }), this.productBlock.removeEventListener("mouseenter", this.mouseEnterProductBlockHandler), this.productBlock.removeEventListener("mouseenter", this.mouseEnterImageContainerHandler), this.productBlock.removeEventListener("mouseleave", this.mouseLeaveImageContainerHandler), window.removeEventListener("resize", this.windowResizeHandler), this.swatchesContainer && this.swatchesContainer.removeEventListener("mouseleave", this.mouseLeaveSwatchHandler)
        }
    }
    class v extends l {
        constructor() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "product-block",
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(e, ":not(.cc-initialized)");
            super(e, t)
        }
        init(e) {
            super.init(e), this.registerInstance(e, new m(e))
        }
        destroy(e) {
            this.destroyInstance(e), super.destroy(e)
        }
    }
    new v, theme.HeaderSection = new function () {
        var t, a = 0,
            o = e(".cc-announcement");
        handleScroll = function n(s, r, l) {
            "opaque_on_scroll" === l || "opaque_on_scroll_alt" === l ? 100 > e(window).scrollTop() ? s.bar.turnOpaque(!1) : s.bar.turnOpaque(!0) : "opaque" !== l && s.bar.turnOpaque(!1);
            var c = e(window).scrollTop();
            ("peek" === r || s.bar.isAnnouncementBar() && "sticky" == r) && c > 100 ? (a = c, "sticky" != r && (t < a && c > 100 ? s.bar.hide(!0) : t > a && !(c <= 50) && s.bar.hide(!1)), t = a) : s.bar.hide(!1), ("sticky" == r || "peek" == r) && o.length > 0 && (c <= 50 ? s.bar.hideAnnouncement(!1) : s.bar.hideAnnouncement(!0))
        }, this.onSectionLoad = function (t) {
            theme.addControlPaddingToModal(), e("body").toggleClass("modal-active", e(".theme-modal.reveal").length > 0), e("#page-menu a", t).attr("tabindex", "-1"), e("#page-menu .main-nav li:has(ul)", t).addClass("has-children"), e("#page-menu.nav-uses-modal .main-nav li.has-children > a", t).append('<span class="arr">' + theme.icons.chevronRight + "</span>"), e(".disclosure", t).each(function () {
                e(this).data("disclosure", new theme.Disclosure(e(this)))
            });
            var o = new theme.Nav,
                n = o.bar.getPositionSetting(),
                s = o.bar.getOpacitySetting();
            if ("opaque" === s ? e("body").addClass("nav-opaque") : e("body").removeClass("nav-opaque"), "inline" === n ? e("body").addClass("nav-inline") : e("body").removeClass("nav-inline"), "opaque" !== s ? e("body").addClass("nav-transparent") : e("body").removeClass("nav-transparent"), o.bar.isAnnouncementBar() ? e("body").addClass("showing-announcement") : e("body").removeClass("showing-announcement"), ("opaque_on_scroll" === s || "opaque_on_scroll_alt" === s || "peek" === n || o.bar.isAnnouncementBar()) && (a = 0, e(window).on("throttled-scroll.nav", function () {
                    handleScroll(o, n, s)
                })), e(document).on("click.video-section", ".video-container__play", function () {
                    theme.viewport.isXs() && o.bar.fadeOut(!0)
                }), e(document).on("click.video-section", ".video-container__stop", function () {
                    theme.viewport.isXs() && o.bar.fadeOut(!1)
                }), o.bar.hasInlineLinks() && o.bar.hasLocalization()) {
                var r = e(".logo", t),
                    l = e(".nav-right-side", t);
                e(window).on("debouncedresize.headerSection doNavResizeEvents.headerSection", function e() {
                    theme.viewport.isXlg() && l.width() > r.width() ? r.css("width", l.outerWidth() - 20 + "px") : r.css("width", "")
                }).trigger("doNavResizeEvents");
                var c = new CustomEvent("cc-header-updated");
                window.dispatchEvent(c)
            }
            setTimeout(function () {
                e(".lazyload--manual", t).removeClass("lazyload--manual").addClass("lazyload")
            }, 5e3), theme.checkViewportFillers(), theme.assessAltLogo(), e(window).trigger("cc-header-updated")
        }, this.onSectionUnload = function (t) {
            e(".disclosure", t).each(function () {
                e(this).data("disclosure").unload()
            }), e(window).off("throttled-scroll.nav"), e(window).off("headerSection"), e(document).on("click.video-section")
        }
    }, theme.FooterSection = new function () {
        this.onSectionLoad = function (t) {
            this.footerSectionElem = t.parentElement, e(".disclosure", t).each(function () {
                e(this).data("disclosure", new theme.Disclosure(e(this)))
            }), this.observer = new MutationObserver(this.functions.observeMutation.bind(this)), t.querySelectorAll(".disclosure__toggle").forEach(e => {
                this.observer.observe(e, {
                    attributes: !0
                })
            })
        }, this.onSectionUnload = function (t) {
            e(".disclosure", t).each(function () {
                e(this).data("disclosure").unload()
            }), this.observer.disconnect()
        }, this.functions = {
            observeMutation: function e(t) {
                t.forEach(e => {
                    "attributes" === e.type && "aria-expanded" === e.attributeName && this.footerSectionElem.classList.toggle("disclosure--open", "true" === e.target.getAttribute("aria-expanded"))
                })
            }
        }
    }, theme.SlideshowSection = new function () {
        this.onSectionLoad = function (t) {
            theme.initContentSlider(t), e(window).trigger("slideshowfillheight"), theme.checkViewportFillers(), theme.assessAltLogo()
        }, this.onSectionUnload = function (t) {
            e(".slick-slider", t).slick("unslick").off("init"), e(window).off(".slideshowSection")
        }, this.onBlockSelect = function (t) {
            e(t).closest(".slick-slider").slick("slickGoTo", e(t).data("slick-index")).slick("slickPause")
        }, this.onBlockDeselect = function (t) {
            e(t).closest(".slick-slider").slick("slickPlay")
        }
    }, theme.FeaturedBlogSection = new function () {
        this.onSectionLoad = function (t) {
            if (e(".carousel-blog", t).length) {
                var a = e(".swiper-container", t);
                1 === a.length && theme.initProductSlider(a, !0)
            }
            if (e(".slideshow-blog", t).length) {
                theme.initContentSlider(t, function (a) {
                    e(".slideshow-blog__titles__active", t).removeClass("slideshow-blog__titles__active"), e('[data-go-to-slide="'.concat(a, '"]'), t).parent().addClass("slideshow-blog__titles__active")
                });
                var o = e(".slideshow-blog__titles", t);
                if (e('.slideshow[data-title-navigation="true"]', t).length) {
                    function n() {
                        theme.viewport.isSm() ? e(".overlay-type .inner", t).css("padding-bottom", o.height() + 50 + "px") : e(".overlay-type .inner", t).removeAttr("style")
                    }
                    n(), e(window).on("debouncedresize.titleNavHeight", n), e("[data-go-to-slide]", t).on("click", function () {
                        var a = e(this).data("go-to-slide");
                        return e(".slideshow", t).slick("slickGoTo", a).slick("slickPause"), e(".slideshow-blog", t).addClass("slideshow--paused"), !1
                    }), e("[data-go-to-slide]:first", t).parent().addClass("slideshow-blog__titles__active")
                }
                e(window).trigger("slideshowfillheight")
            }
            theme.checkViewportFillers(), theme.assessAltLogo()
        }, this.onSectionUnload = function (t) {
            e(".slick-slider", t).slick("unslick").off("init"), e(window).off("debouncedresize.titleNavHeight"), e("[data-go-to-slide]", t).off("click")
        }
    }, theme.ImageWithTextOverlay = new function () {
        var t = this;
        t.checkTextOverImageHeights = function () {
            e('[data-section-type="image-with-text-overlay"], [data-nested-section-type="image-with-text-overlay"]').each(function () {
                var t = e(".rimage-outer-wrapper", this),
                    a = e(".rimage-wrapper", this).outerHeight(),
                    o = parseInt(e(".overlay", this).css("padding-top")),
                    n = e(".overlay__content", this).height() + 2 * o;
                n > a + 2 ? t.css("height", n) : t.css("height", "")
            })
        }, this.onSectionLoad = function (a) {
            e(window).off(".imageWithTextOverlaySection"), e(".overlay__content", a).length && (e(t.checkTextOverImageHeights), e(window).on("debouncedresize.imageWithTextOverlaySection", t.checkTextOverImageHeights)), theme.checkViewportFillers()
        }, this.onSectionUnload = function (t) {
            e(window).off(".imageWithTextOverlaySection")
        }
    }, theme.ImageBesideImageSection = new function () {
        var t = this;
        t.checkTextOverImageHeights = function () {
            e(".image-beside-image__image").each(function () {
                var t = e(".rimage-outer-wrapper", this),
                    a = e(".rimage-wrapper", this).outerHeight(),
                    o = parseInt(e(".overlay", this).css("padding-top")),
                    n = e(".overlay__content", this).height() + 2 * o;
                n > a + 2 ? t.css("height", n) : t.css("height", "")
            })
        }, this.onSectionLoad = function (a) {
            e(window).off(".imageBesideImageSection"), e(".overlay__content", a).length && (e(t.checkTextOverImageHeights), e(window).on("debouncedresize.imageBesideImageSection", t.checkTextOverImageHeights)), theme.checkViewportFillers()
        }, this.onSectionUnload = function (t) {
            e(window).off(".imageBesideImageSection")
        }
    }, theme.ProductTemplateSection = new function () {
        var t = theme.Nav(),
            a = {};
        this.onSectionLoad = function (o) {
            var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                s = new Date().getTime();
            e(o).attr("data-section-id", s);
            var r = e(o).data("is-featured-product") || !1;
            r || n || !e("[data-store-availability-container]", o).length || (this.storeAvailability = new theme.StoreAvailability(e("[data-store-availability-container]", o)[0])), theme.checkViewportFillers(), theme.assessAltLogo(), !t.bar.isCurrentlyOpaque() || r || n || e("body").removeClass("header-section-overlap");
            var l = e(".theme-gallery", o);
            if (l.length > 0 && (a[s] = new theme.ProductMediaGallery(l, e(".theme-gallery-thumb", o), r, n, s)), !r) {
                var c = e(".product-area__add-to-cart-xs", o),
                    d = !c.length,
                    h = !1,
                    u = e(".section-product-template")[0];

                function p() {
                    !theme.viewport.isXs() || d || n || (e(window).on("throttled-scroll.sticky-add-to-cart", function () {
                        u.getBoundingClientRect().bottom < e(window).outerHeight() ? h || (c.addClass("-out"), h = !0) : h && (c.removeClass("-out"), h = !1)
                    }), e(".product-area__add-to-cart-xs button", o).on("click", function (t) {
                        e(".product-detail__form form.product-purchase-form:first", o).submit()
                    }), d = !0)
                }
                e(window).on("debouncedresizewidth.productDetails".concat(s), p), e(window).on("cc-header-updated.productDetails".concat(s), p), e(window).on("shopify:section:reorder.productDetails".concat(s), p), p()
            }
            theme.convertOptionsToBoxes(o), theme.OptionManager.initProductOptions(e(o)), e("select:not(.original-selector)").selectReplace().closest(".selector-wrapper").addClass("has-pretty-select"), e(".size-chart-link", o).on("click", function () {
                return e.colorbox({
                    inline: !0,
                    fixed: !0,
                    maxHeight: "80%",
                    href: "#size-chart-content > .size-chart",
                    onOpen() {
                        theme.viewport.scroll.lock()
                    },
                    onClosed() {
                        theme.viewport.scroll.unlock()
                    }
                }), !1
            }), e(window).on("cc-variant-updated.product-swatches".concat(s), (t, a) => {
                var n = e(".cc-swatches", o);
                n.length && (n.find(".cc-swatches__label").remove(), n.find("label").append('<span class="cc-swatches__label">'.concat(n.find(".active").text(), "</span>")))
            }), theme.initAnimateOnScroll(), theme.checkViewportFillers(), theme.initShopifyPaymentButtons(e(o))
        }, this.onSectionUnload = function (t, o) {
            var n = e(t).attr("data-section-id");
            o || e(window).off("throttled-scroll.sticky-add-to-cart"), e(window).off(".productDetails".concat(n)), e(window).off("cc-variant-updated.product-swatches".concat(n)), e(".spr-container", t).off("click"), e(".theme-gallery-thumb", t).off("click"), e(".size-chart-link", t).off("click"), e(".product-area__add-to-cart-xs button", t).off("click"), theme.OptionManager.unloadProductOptions(e(t)), a[n] ? a[n].destroy() : console.warn("No galleries found"), this.storeAvailability && !o && this.storeAvailability.onSectionUnload()
        }
    }, theme.FilterManager = new function () {
        this.onSectionLoad = function (t) {
            this.namespace = theme.namespaceFromSection(t), this.$container = e(t), this.$container.data("ajax-filtering") ? (this.$container.on("click" + this.namespace, ".pagination a,.active-filter-controls a", this.functions.ajaxLoadLink.bind(this)), this.$container.on("change" + this.namespace + " submit" + this.namespace, "#FacetsForm", theme.debounce(this.functions.ajaxLoadForm.bind(this), 700)), this.registerEventListener(window, "popstate", this.functions.ajaxPopState.bind(this))) : this.$container.on("change" + this.namespace, "#FacetsForm", this.functions.submitForm), this.$container.on("click" + this.namespace, "[data-show-filter]", this.functions.toggleFilter.bind(this)), this.$container.on("submit" + this.namespace, "#search-page-form", this.functions.updateSearchQuery.bind(this)), theme.loadInfiniteScroll(t), this.functions.refreshSelects()
        }, this.onSectionUnload = function (t) {
            this.$container.off(this.namespace), e(window).off(this.namespace), e(document).off(this.namespace), theme.unloadInfiniteScroll()
        }, this.functions = {
            submitForm: function e(t) {
                t.currentTarget.submit()
            },
            updateSearchQuery: function t(a) {
                var o = this.$container.find("#FacetsForm");
                o.length && ((a.preventDefault(), o.find('[name="q"]').val(e(a.currentTarget).find('[name="q"]').val()), this.$container.data("ajax-filtering")) ? this.functions.ajaxLoadForm.bind(this)({
                    type: null,
                    currentTarget: o[0]
                }) : o.submit())
            },
            toggleFilter: function t() {
                var a = e("[data-show-filter]", this.$container),
                    o = e(".cc-product-filter", this.$container),
                    n = theme.Nav();
                return o.hasClass("-in") ? (a.text(a.data("open-text")), n.bar.fadeOut(!1)) : (a.text(a.data("close-text")), n.bar.fadeOut(!0)), o.toggleClass("-in"), !1
            },
            ajaxLoadLink: function t(a) {
                a.preventDefault(), this.functions.ajaxLoadUrl.call(this, e(a.currentTarget).attr("href"))
            },
            ajaxLoadForm: function e(t) {
                "submit" === t.type && t.preventDefault();
                var a = [];
                t.currentTarget.querySelectorAll("input, select").forEach(e => {
                    ("checkbox" !== e.type && "radio" !== e.type || e.checked) && "" !== e.value && ("" === e.value && e.dataset.currentValue ? a.push([e.name, encodeURIComponent(e.dataset.currentValue)]) : a.push([e.name, encodeURIComponent(e.value)]))
                }), t.currentTarget.querySelectorAll("[data-current-value]").forEach(e => {
                    e.setAttribute("value", e.dataset.currentValue)
                });
                var o = new FormData(t.currentTarget),
                    n = new URLSearchParams(o).toString();
                this.functions.ajaxLoadUrl.call(this, "?" + n)
            },
            ajaxPopState: function e(t) {
                this.functions.ajaxLoadUrl.call(this, document.location.href)
            },
            initFilterResults: function t() {
                theme.loadInfiniteScroll(this.container), theme.inlineVideos.init(this.container), theme.initAnimateOnScroll();
                var a = this.$container.closest("[data-components]");
                a.length && a.data("components").split(",").forEach((function (t) {
                    e(document).trigger("cc:component:load", [t, a[0]])
                }).bind(this))
            },
            refreshSelects: function t() {
                e("select:not(.original-selector)", this.$container).selectReplace().closest(".selector-wrapper").addClass("has-pretty-select")
            },
            ajaxLoadUrl: function t(a) {
                var o = this,
                    n = a;
                "/" === n.slice(0, 1) && (n = window.location.protocol + "//" + window.location.host + n);
                var s = "[data-ajax-container]",
                    r = this.$container.find(s);
                r.addClass("cc-product-filter-container--loading"), r.find(".product-list").append('<span class="loading" aria-label="'.concat(theme.strings.loading, '">').concat(theme.icons.loading, " </span>")), theme.unloadInfiniteScroll(this.$container), theme.inlineVideos.destroy(this.$container), this.currentAjaxLoadUrlFetch && this.currentAjaxLoadUrlFetch.abort(), this.currentAjaxLoadUrlFetch = e.get(a, (function (t) {
                    this.currentAjaxLoadUrlFetch = null;
                    var a = e(e.parseHTML(t)).filter("title").text().trim();
                    document.title = a, window.history.pushState({
                        path: n
                    }, a, n), document.activeElement && (this.activeElementId = document.activeElement.id), e("<div>".concat(t, "</div>")).find(s).each(function (t) {
                        var a = e(this);
                        e(r[t]).find(".cc-accordion-item").each(function () {
                            var t = e(this).closest(".cc-accordion").index();
                            e(this).hasClass("is-open") ? a.find(".cc-accordion:nth-child(".concat(t + 1, ") .cc-accordion-item")).addClass("is-open").attr("open", "") : a.find(".cc-accordion:nth-child(".concat(t + 1, ") .cc-accordion-item")).removeClass("is-open").removeAttr("open")
                        }), e(".cc-product-filter", o.$container).length && e(".cc-product-filter", o.$container).hasClass("-in") && a.find(".cc-product-filter").addClass("-in"), e(r[t]).html(a.html()), o.functions.refreshSelects()
                    }), this.functions.initFilterResults.call(this);
                    var l = e(".cc-product-filter", o.$container),
                        c = e("[data-show-filter]", o.$container);
                    if (l.length && l.hasClass("-in")) {
                        var d, h = e(".product-list", o.$container).data("result-count");
                        d = 1 === h ? c.data("result-count-text-singular").replace("[x]", h) : c.data("result-count-text").replace("[x]", h), c.text(d)
                    }
                    if (r.removeClass("cc-product-filter-container--loading"), this.activeElementId) {
                        var u = document.getElementById(this.activeElementId);
                        u && u.focus()
                    }
                    var p = e("[data-ajax-scroll-to]:first", this.$container);
                    e(window).scrollTop() - 200 > p.offset().top && theme.viewport.scroll.to(p, -1, 25)
                }).bind(this))
            }
        }
    }, theme.ListCollectionsSection = new function () {
        this.onSectionLoad = function (e) {}
    }, theme.BlogTemplateSection = new function () {
        this.onSectionLoad = function (t) {
            e("select").selectReplace(), theme.allowRTEFullWidthImages(t)
        }
    }, theme.ArticleTemplateSection = new function () {
        this.onSectionLoad = function (e) {
            theme.checkViewportFillers(), theme.assessAltLogo(), theme.allowRTEFullWidthImages(e)
        }
    }, theme.CartTemplateSection = new function () {
        this.onSectionLoad = function (t) {
            theme.cartNoteMonitor.load(e('#cartform [name="note"]', t)), e("#cartform input#terms", t).length > 0 && e(document).on("click.cartTemplateSection", '#cartform [name="checkout"]:submit, .additional-checkout-buttons :submit, .additional-checkout-buttons input[type=image], a[href="/checkout"]', function () {
                if (0 == e("#cartform input#terms:checked").length) return alert(theme.strings.cartConfirmation), !1
            })
        }, this.onSectionUnload = function (t) {
            theme.cartNoteMonitor.unload(e('#cartform [name="note"]', t)), e(document).off(".cartTemplateSection")
        }
    }, theme.CollectionListSection = new function () {
        this.onSectionLoad = function (t) {
            var a = e(".swiper-container", t);
            1 === a.length && theme.initProductSlider(a)
        }
    }, theme.FeaturedCollectionSection = new function () {
        this.onSectionLoad = function (t) {
            var a = e(".swiper-container", t);
            1 === a.length && theme.initProductSlider(a)
        }
    }, theme.ProductRecommendations = new function () {
        this.onSectionLoad = function (t) {
            var a = document.querySelector(".product-recommendations");
            if (null !== a) {
                var o = new XMLHttpRequest;
                o.open("GET", a.dataset.url, !0), o.onload = function () {
                    if (o.status >= 200 && o.status < 300) {
                        var t = document.createElement("div");
                        t.innerHTML = o.response, a.innerHTML = t.querySelector(".product-recommendations").innerHTML, theme.initAnimateOnScroll();
                        var n = e(".section-product-recommendations .swiper-container");
                        1 === n.length ? (theme.initProductSlider(n), setTimeout(() => {
                            theme.inlineVideos.init(a.parentElement), new v
                        }, 500)) : console.warn("Unable to find .section-product-recommendations")
                    }
                }, o.send()
            }
        }, this.onSectionUnload = function (e) {
            theme.inlineVideos.destroy(e)
        }
    }, theme.GallerySection = new function () {
        this.onSectionLoad = function (t) {
            var a = e(".gallery--mobile-carousel", t);
            if (a.length) {
                var o = function t() {
                    var o = a.hasClass("slick-slider"),
                        n = theme.viewport.isXs();
                    if (n || e(".lazyload--manual", a).removeClass("lazyload--manual").addClass("lazyload"), o && !n) {
                        a.slick("unslick").off("init"), a.removeAttr("data-transition"), a.removeClass("slideshow"), a.find("a, .gallery__item").removeAttr("tabindex").removeAttr("role");
                        var s = a.data("grid"),
                            r = null;
                        a.find(".gallery__item").each(function (t) {
                            t % s == 0 && (r = e('<div class="gallery__row">').appendTo(a)), e(this).appendTo(r)
                        })
                    } else !o && n && (a.find("[data-cc-animate]").removeAttr("data-cc-animate"), a.find(".gallery__item").appendTo(a).addClass("slide"), a.find(".gallery__row").remove(), a.attr("data-transition", "slide"), a.addClass("slideshow"), a.on("init", function () {
                        e(".lazyload--manual", this).removeClass("lazyload--manual").addClass("lazyload")
                    }).slick({
                        autoplay: !1,
                        fade: !1,
                        speed: 600,
                        infinite: !0,
                        useTransform: !0,
                        arrows: !1,
                        dots: !0,
                        cssEase: "cubic-bezier(0.25, 1, 0.5, 1)",
                        customPaging: function e(t, a) {
                            return '<button class="custom-dot" type="button" data-role="none" role="button" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" xml:space="preserve"><circle class="circle-one" cx="15" cy="15" r="13" /><circle class="circle-two" cx="15" cy="15" r="13" /></svg></button>'
                        }
                    }).on("beforeChange", function (t, a, o, n) {
                        e(a.$slides.get(o)).addClass("slick--leaving")
                    }).on("afterChange", function (t, a, o) {
                        e(a.$slides).filter(".slick--leaving").removeClass("slick--leaving")
                    }))
                };
                o(), e(window).on("debouncedresize.themeSection" + t.id, o)
            }
        }, this.onSectionUnload = function (t) {
            e(window).off(".themeSection" + t.id), e(".slick-slider", t).each(function () {
                e(this).slick("unslick").off("init")
            })
        }, this.onBlockSelect = function (t) {
            e(t).closest(".slick-slider").each(function () {
                e(this).slick("slickGoTo", e(this).data("slick-index")).slick("slickPause")
            })
        }, this.onBlockDeselect = function (t) {
            e(t).closest(".slick-slider").each(function () {
                e(this).slick("slickPlay")
            })
        }
    }, theme.TestimonialsSection = new function () {
        var e;
        this.onSectionLoad = function (t) {
            theme.settings.animationEnabledDesktop && theme.viewport.isSm() && (e = new Scrollax(window).init())
        }, this.onSectionUnload = function (t) {
            e && e.Scrollax && e.Scrollax("destroy")
        }
    }, theme.AccordionSection = new function () {
        this.onSectionLoad = function (e) {
            var t = new CustomEvent("cc-accordion-load");
            window.dispatchEvent(t)
        }, this.onBlockSelect = function (e) {
            var t = e.querySelector(".cc-accordion-item:not(.is-open) .cc-accordion-item__title");
            t && t.click()
        }, this.onSectionUnload = function (e) {
            var t = new CustomEvent("cc-accordion-unload");
            window.dispatchEvent(t)
        }
    }, theme.FaqSection = new function () {
        this.onSectionLoad = function (e) {
            this.intersectionObserver, this.namespace = theme.namespaceFromSection(e), this.container = e, this.pageContent = document.getElementById("page-content"), this.sidebar = document.getElementById("faq-sidebar"), this.accordions = this.pageContent.querySelectorAll(".cc-accordion-item__title"), this.isScrolling = !1, this.classNames = {
                questionContainerHidden: "hidden"
            }, this.functions.initFaqSections.call(this), window.addEventListener("shopify:section:load", this.functions.delayedInitFaqSections.bind(this)), window.addEventListener("shopify:section:unload", this.functions.delayedInitFaqSections.bind(this)), window.addEventListener("shopify:section:reorder", this.functions.initFaqSections.bind(this)), this.searchInput = this.container.querySelector("#faq-search__input"), this.searchInput && (this.registerEventListener(this.searchInput, "change", this.functions.performSearch.bind(this)), this.registerEventListener(this.searchInput, "keyup", this.functions.performSearch.bind(this)), this.registerEventListener(this.searchInput, "paste", this.functions.performSearch.bind(this))), "true" === this.container.dataset.sidebarEnabled && (this.functions.initSidebar.call(this), window.addEventListener("resize", this.functions.debounceUpdateSidebarPosition), window.addEventListener("shopify:section:load", this.functions.delayedInitSidebar.bind(this)), window.addEventListener("shopify:section:unload", this.functions.delayedInitSidebar.bind(this)), window.addEventListener("shopify:section:reorder", this.functions.initSidebar.bind(this)), this.accordions.forEach(e => {
                e.addEventListener("click", this.functions.debounceUpdateSidebarPosition)
            }), document.body.classList.add("faq-sidebar-enabled"))
        }, this.onSectionUnload = function (e) {
            "true" === this.container.dataset.sidebarEnabled && (window.removeEventListener("resize", this.functions.debounceUpdateSidebarPosition), window.removeEventListener("shopify:section:load", this.functions.delayedInitSidebar), window.removeEventListener("shopify:section:unload", this.functions.delayedInitSidebar), window.removeEventListener("shopify:section:reorder", this.functions.initSidebar), document.body.classList.remove("faq-sidebar-enabled")), window.removeEventListener("shopify:section:load", this.functions.delayedInitFaqSections), window.removeEventListener("shopify:section:unload", this.functions.delayedInitFaqSections), window.removeEventListener("shopify:section:reorder", this.functions.initFaqSections), document.querySelectorAll(".section-faq-accordion").forEach(e => {
                e.classList.remove("section-faq-accordion")
            }), this.intersectionObserver && this.pageContent.querySelectorAll(".section-faq-accordion h2 a").forEach(e => this.intersectionObserver.unobserve(e)), this.accordions.forEach(e => {
                e.removeEventListener("click", this.functions.updateSidebarPosition)
            }), this.pageContent.classList.remove("faq-search-active")
        }, this.functions = {
            initFaqSections: function e() {
                this.pageContent.querySelectorAll(".section-faq-accordion").forEach(e => e.classList.remove("section-faq-accordion"));
                var t = !1,
                    a = !1;
                this.pageContent.querySelectorAll(".shopify-section").forEach(e => {
                    t ? e.classList.contains("section-accordion") && !1 === a ? e.classList.add("section-faq-accordion") : a = !0 : e.classList.contains("section-faq") && (t = !0)
                })
            },
            delayedInitFaqSections: function e() {
                setTimeout(this.functions.initFaqSections.bind(this), 10)
            },
            performSearch: function e() {
                setTimeout((() => {
                    var e = this.searchInput.value.toLowerCase().split(" "),
                        t = this.pageContent.querySelectorAll(".section-faq-accordion .cc-accordion"),
                        a = [];
                    e.forEach(e => {
                        e.length > 0 && a.push(e)
                    }), a.length > 0 ? this.pageContent.classList.add("faq-search-active") : this.pageContent.classList.remove("faq-search-active");
                    var o = this.pageContent.querySelectorAll(".section-faq-accordion");
                    o && o.forEach(e => {
                        e.classList.remove("faq-first-answer"), a.length > 0 ? e.dataset.foundCount = "0" : e.removeAttribute("data-found-count")
                    });
                    var n = !0;
                    if (t.forEach((e => {
                            var t = 0;
                            if (a.length) {
                                var o = !1,
                                    s = e.textContent.toLowerCase();
                                a.forEach(t => {
                                    s.includes(t) && (n && e.closest(".section-accordion").classList.add("faq-first-answer"), o = !0, n = !1)
                                }), o ? (e.classList.remove(this.classNames.questionContainerHidden), t++) : e.classList.add(this.classNames.questionContainerHidden)
                            } else e.classList.remove(this.classNames.questionContainerHidden);
                            var r = e.closest(".section-accordion");
                            r.dataset.foundCount = parseInt(r.dataset.foundCount) + t
                        }).bind(this)), n && a.length ? this.container.classList.add("faq-no-results") : this.container.classList.remove("faq-no-results"), "true" === this.container.dataset.sidebarEnabled) {
                        var s = this.sidebar.querySelector(".faq-sidebar--active");
                        s && s.classList.remove("faq-sidebar--active"), this.sidebar.querySelectorAll("a").forEach(e => {
                            var t = e.getAttribute("href").replace("#", ""),
                                a = document.getElementById(t);
                            a && (null === a.offsetParent ? e.classList.add("faq-sidebar--disabled") : (e.classList.remove("faq-sidebar--disabled"), this.sidebar.querySelector(".faq-sidebar--active") || e.classList.add("faq-sidebar--active")))
                        }), this.functions.updateSidebarPosition()
                    }
                }).bind(this), 10)
            },
            initSidebar: function e() {
                var t = "";
                this.pageContent.querySelectorAll(".section-faq-accordion .section-heading h2").forEach((e, a) => {
                    var o = e.innerText,
                        n = "faq-" + JSON.stringify(o.toLowerCase()).replace(/\W/g, "");
                    e.innerHTML = '<a id="'.concat(n, '"></a>').concat(o), t += '<li><a href="#'.concat(n, '" ').concat(0 === a ? 'class="faq-sidebar--active"' : "", ">").concat(o, "</a></li>")
                });
                var a = new theme.Nav,
                    o = a.bar.hasStickySetting() ? a.bar.height() + 50 : 50;
                this.sidebar.innerHTML = '<div class="faq-sidebar__inner" style="top: '.concat(parseInt(o), 'px">\n          ').concat(this.container.dataset.sidebarTitle ? "<h3>" + this.container.dataset.sidebarTitle + "</h3>" : "", "\n          <ol>").concat(t, "</ol>\n        </div>"), this.sidebar.querySelectorAll("a").forEach(e => {
                    this.registerEventListener(e, "click", this.functions.handleIndexClick.bind(this))
                }), "IntersectionObserver" in window && (this.intersectionObserver = new IntersectionObserver((e, t) => {
                    e.forEach(e => {
                        e.isIntersecting && !this.isScrolling && this.sidebar.querySelectorAll("a").forEach(t => {
                            t.getAttribute("href").replace("#", "") === e.target.getAttribute("id") ? t.classList.add("faq-sidebar--active") : t.classList.remove("faq-sidebar--active")
                        })
                    })
                }, {
                    rootMargin: "0px 0px -70%"
                }), this.pageContent.querySelectorAll(".section-faq-accordion h2 a").forEach(e => this.intersectionObserver.observe(e))), this.functions.updateSidebarPosition()
            },
            delayedInitSidebar: function e() {
                setTimeout(this.functions.initSidebar.bind(this), 20)
            },
            updateSidebarPosition: function e() {
                var t = document.getElementById("faq-sidebar"),
                    a = document.querySelector(".section-faq"),
                    o = !1,
                    n = null;
                if (a) {
                    document.querySelectorAll("#page-content .shopify-section").forEach(e => {
                        o ? null !== n || e.classList.contains("section-accordion") || (n = e) : e.classList.contains("section-faq") && (o = !0)
                    }), n || (n = document.querySelector(".section-footer"));
                    var s = a.getBoundingClientRect().top + document.documentElement.scrollTop,
                        r = window.getComputedStyle(document.body).getPropertyValue("padding-top");
                    if (r = parseInt(r.replace("px", "")), t.style.top = s - r + "px", n) {
                        var l = n.getBoundingClientRect().top + document.documentElement.scrollTop;
                        t.style.height = l - s + "px";
                        var c = t.querySelector(".faq-sidebar__inner");
                        c && (c.style.maxHeight = l - s - 100 + "px")
                    }
                }
            },
            debounceUpdateSidebarPosition: theme.debounce(() => this.functions.updateSidebarPosition),
            handleIndexClick: function e(t) {
                t.preventDefault();
                var a = this.sidebar.querySelector(".faq-sidebar--active");
                a && a.classList.remove("faq-sidebar--active"), t.target.classList.add("faq-sidebar--active"), this.isScrolling = !0, theme.viewport.scroll.to(t.currentTarget.getAttribute("href"), -1, 50, () => {
                    this.isScrolling = !1
                })
            }
        }
    }, theme.ScrollingTextSection = new function () {
        this.onSectionLoad = function (e) {
            document.fonts.ready.then(() => e.querySelector(".marquee").classList.add("marquee--animate"))
        }
    }, jQuery(function (e) {
        lazySizesConfig.minSize = 200;
        var t = theme.Nav();
        e("select:not(.original-selector)").selectReplace().closest(".selector-wrapper").addClass("has-pretty-select"), e("a[rel=lightbox]").colorbox(), theme.viewport.isSm() && e('a[rel="gallery"]').colorbox({
            rel: "gallery"
        }), e.extend(e.colorbox.settings, {
            previous: theme.strings.colorBoxPrevious,
            next: theme.strings.colorBoxNext,
            close: theme.icons.close
        }), e(".rte a img").closest("a").addClass("contains-img"), theme.lastViewportWidth = 0, e(window).on("debouncedresize slideshowfillheight", function (a) {
            if ("debouncedresize" != a.type || theme.lastViewportWidth != e(window).width()) {
                var o = e(window).height();
                t.bar.isAnnouncementBar() && (o -= t.bar.heightOfAnnouncementBar()), e(".slideshow.fill-viewport, .slideshow.fill-viewport .slide").css("min-height", o), e(".slideshow.fill-viewport").each(function () {
                    var t = 0;
                    e(this).find(".slide").each(function () {
                        var a = 0;
                        e(".fill-viewport__contain", this).each(function () {
                            a += e(this).outerHeight(!0)
                        }), t < a && (t = a)
                    }), t > o && (e(this).css("min-height", t), e(".slide", this).css("min-height", t))
                }), theme.lastViewportWidth = e(window).width(), e("body.header-section-overlap").length && t.bar.isAnnouncementBar() ? e("#page-content").css("margin-top", t.bar.heightOfAnnouncementBar()) : e("#page-content").css("margin-top", "")
            }
        }), e(window).on("scroll assessFeatureHeaders", function () {
            var t = e(window).scrollTop(),
                a = t + e(window).height() - 60;
            e("body").toggleClass("scrolled-down", t > 0), theme.assessAltLogo(), e(".feature-header:not(.feature-header--visible)").filter(function () {
                var o = e(this).offset().top,
                    n = e(this).outerHeight();
                return o + n >= t && o <= a
            }).addClass("feature-header--visible")
        }), e.fn.slideUpAndRemove = function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 200;
            e(this).each(function () {
                e(this).slideUp(t, function () {
                    e(this).remove()
                })
            })
        };
        var a = ["_root"];
        updateNavCtas = function t() {
            var n = a[a.length - 1],
                s = e('#page-menu .nav-ctas__container[data-for-nav-item="'.concat(n, '"]:hidden'));
            s.length > 0 ? e("#page-menu .nav-ctas__container:visible").length ? e("#page-menu .nav-ctas__container:visible").fadeOut(o, function () {
                s.fadeIn(o)
            }) : setTimeout(function () {
                s.fadeIn(o)
            }, o) : e("#page-menu .nav-ctas__container:visible").fadeOut(o)
        };
        var o = 250;

        function n() {
            return e("#page-content").outerHeight() > e(window).height()
        }
        e(document).on("click", "#page-menu.nav-uses-modal .main-nav li.has-children > a", function () {
            var t = e(this).text().replace(/^\s\s*/, "").replace(/\s\s*$/, "").toLowerCase();
            a.push(t);
            var n = e('<div class="container growth-area"/>').append(e(this).siblings("ul").clone().wrap('<div class="nav-body main-nav growth-area"/>').parent()),
                s = n.find(".main-nav > ul").wrap("<li/>").parent().wrap("<ul/>").parent();
            theme.strings.back.length > 0 && s.prepend('<li class="main-nav__back" data-nav-title="'.concat(t, '"><a href="#" data-revert-back><span class="arr arr--left">').concat(theme.icons.chevronLeft, "</span>").concat(theme.strings.back, "</a></li>"));
            var r = e("#page-menu > .inner > .nav-container > .container:not(.inactive)");
            return r.addClass("inactive").fadeOut(o, function () {
                n.hide().insertAfter(r.last()).fadeIn(o), n.closest(".theme-modal").focus()
            }), updateNavCtas(), e("#page-menu > .inner > .nav-container > .nav-footer-links").fadeOut(o), !1
        }), e(document).on("click", "#page-menu.nav-uses-modal a[data-revert-back]", function () {
            return a.pop(), updateNavCtas(), e("#page-menu.nav-uses-modal > .inner > .nav-container > .container:not(.inactive)").fadeOutAndRemove(o, function () {
                var t = e("#page-menu.nav-uses-modal > .inner > .nav-container > .container.inactive:last");
                t.removeClass("inactive").fadeIn(o), t.data("root-nav") && e("#page-menu > .inner > .nav-container > .nav-footer-links").fadeIn(o)
            }), !1
        }), e(document).on("reset-modal", "#page-menu.nav-uses-modal", function () {
            return closeThemeModal(), setTimeout(function () {
                e("#page-menu.nav-uses-modal > .inner > .nav-container > .container").removeClass("inactive").show().slice(1).remove()
            }, 300), !1
        }).on("click", "a[data-reset-and-close]", function () {
            return e("#page-menu.nav-uses-modal").trigger("reset-modal"), !1
        }), theme.lastHoverInteractionTimestamp = -1, e(document).on("click keydown", ".multi-level-nav .nav-rows .contains-children > a", function (t) {
            if ("click" == t.type || "Enter" == t.key) return e(this).parent().find("ul:first").slideToggle(300), !1
        }), e(document).on(theme.device.isTouch() ? "click forceopen forceclose" : "forceopen forceclose", ".multi-level-nav .contains-mega-menu a.has-children", function (t) {
            if (e(".nav-ctas__cta .lazyload--manual").removeClass("lazyload--manual").addClass("lazyload"), e(this).hasClass("column-title")) return !0;
            var a = Date.now();
            if ("click" == t.type && a - theme.lastHoverInteractionTimestamp < 500) return !1;
            ("forceopen" == t.type || "forceclose" == t.type) && (theme.lastHoverInteractionTimestamp = a);
            var o = e(this).closest('[class^="tier-"]'),
                n = o.parent(),
                s = parseInt(o.attr("class").split("-")[1]) + 1,
                r = "tier-" + s;
            if ("forceopen" != t.type && n.children().each(function () {
                    if (parseInt(e(this).attr("class").split("-")[1]) >= s) {
                        if ("forceclose" == t.type) {
                            e(this).removeClass("tier-appeared");
                            var a = e(this);
                            theme.hoverRemoveTierTimeoutId = setTimeout(function () {
                                a.remove()
                            }, 260)
                        } else e(this).slideUpAndRemove(200)
                    }
                }), e(this).hasClass("expanded") && "forceopen" != t.type) e(this).removeClass("expanded").removeAttr("aria-expanded").removeAttr("aria-controls");
            else {
                o.find("a.expanded").removeClass("expanded").removeAttr("aria-expanded"), clearTimeout(theme.hoverRemoveTierTimeoutId);
                var l = n.children("." + r);
                0 == l.length ? (l = e("<div />").addClass(r).attr("id", "menu-" + r).appendTo(n)).css("height", "0px") : l.css("height", l.height() + "px"), l.empty().stop(!0, !1).append(e(this).siblings("ul").clone().attr("style", "")), l.animate({
                    height: l.children().outerHeight()
                }, 200, function () {
                    e(this).css("height", "")
                }), setTimeout(function () {
                    l.addClass("tier-appeared")
                }, 10), e(this).addClass("expanded").attr("aria-expanded", "true").attr("aria-controls", "menu-" + r), e("body").addClass("nav-mega-open")
            }
            return !1
        }), theme.closeOpenMenuItem = function () {
            e("body").removeClass("nav-mega-open"), e(".multi-level-nav.reveal-on-hover .has-children.expanded").trigger("forceclose")
        }, e(document).on("mouseenter mouseleave", ".multi-level-nav.reveal-on-hover .tier-1 .contains-mega-menu", function (t) {
            theme.viewport.isSm() && (clearTimeout(theme.closeOpenMenuItemTimeoutId), "mouseenter" == t.type ? e(this).children("a").trigger("forceopen") : theme.closeOpenMenuItemTimeoutId = setTimeout(theme.closeOpenMenuItem, 200))
        }), e(document).on("mouseleave", ".multi-level-nav.reveal-on-hover .tier-appeared", function (e) {
            theme.viewport.isSm() && (clearTimeout(theme.closeOpenMenuItemTimeoutId), theme.closeOpenMenuItemTimeoutId = setTimeout(theme.closeOpenMenuItem, 50))
        }), e(document).on("mouseenter", ".multi-level-nav.reveal-on-hover .tier-2, .multi-level-nav.reveal-on-hover .tier-3", function (e) {
            theme.viewport.isSm() && clearTimeout(theme.closeOpenMenuItemTimeoutId)
        }), e(document).on("keydown", ".multi-level-nav .contains-children > a.has-children", function (t) {
            if ("Enter" == t.key) return e(this).parent().hasClass("contains-mega-menu") ? "true" == e(this).attr("aria-expanded") ? theme.closeOpenMenuItem() : e(this).trigger("forceopen") : e(this).parent().toggleClass("reveal-child"), !1
        });
        var s = -1;
        window.closeThemeModal = function (t, a) {
            e("a[data-modal-toggle].active").removeClass("active");
            var o = e(".theme-modal.reveal");
            o.removeClass("reveal").addClass("unreveal"), e("html.supports-transforms").length && (void 0 === t || !t) ? s = setTimeout(function () {
                e("body").removeClass("modal-active"), e("body, #page-content, #site-control").css("padding-right", "")
            }, 300) : (e("body").removeClass("modal-active"), e("body, #site-control").css("padding-right", "")), o.find("a").attr("tabindex", "-1"), t ? e("body").removeAttr("data-modal-id") : setTimeout(function () {
                e("body").removeAttr("data-modal-id")
            }, 200), e(window).trigger("ccModalClosing"), setTimeout(function () {
                e("body").removeClass("modal-closing"), "quick-buy-modal" === o.attr("id") && o.remove(), a && a(), e(window).trigger("ccModalClosed")
            }, 300), e("#search-modal").removeClass("-in")
        }, window.showThemeModal = function (t, a, o) {
            closeThemeModal(!0), e(".theme-modal.temp").remove(), theme.Nav().bar.hide(!1);
            var s = e(t);
            s.appendTo("body"), setTimeout(function () {
                s.addClass("reveal")
            }, 10), theme.addControlPaddingToModal();
            var r = e.scrollBarWidth();
            n() && e("#page-content, #site-control").css("padding-right", r), e("body").addClass("modal-active modal-opening"), a && e("body").attr("data-modal-id", a), setTimeout(function () {
                e(".theme-modal:visible [data-modal-close]").length && e(".theme-modal:visible [data-modal-close]").focus(), e("body").removeClass("modal-opening")
            }, 300), r > 0 && e(".theme-modal:visible").addClass("scrollbar-visible"), o && o(s)
        }, window.showInPageModal = function (t) {
            t.removeClass("unreveal").addClass("reveal"), theme.addControlPaddingToModal();
            var a = t.find(".focus-me");
            e(this).addClass("active"), n() && e("body, #site-control").css("padding-right", e.scrollBarWidth()), e("body").addClass("modal-active modal-opening").attr("data-modal-id", t.attr("id")), e("a[tabindex]", t).removeAttr("tabindex"), 0 == a.length ? t.closest(".theme-modal").focus() : theme.viewport.isSm() && a.focus(), "search-modal" === t.attr("id") && setTimeout(function () {
                e("#search-modal").addClass("-in")
            }, 400), setTimeout(function () {
                e("body").removeClass("modal-opening")
            }, 400)
        }, e(document).on("click", "body:not(.modal-active) a[data-modal-toggle]", function (t) {
            t.preventDefault(), window.showInPageModal(e(e(this).data("modal-toggle")))
        }), e(document).on("keyup", function (e) {
            27 == e.which && closeThemeModal()
        }), e(document).on("click", "body.modal-active a[data-modal-close]", function () {
            return closeThemeModal(), !1
        }), e(document).on("click", ".theme-modal", function (t) {
            if (t.target == this) return closeThemeModal(), e(this).trigger("reset-modal"), !1
        }), e(document).on("click", "body.modal-active a[data-modal-toggle]", function () {
            return closeThemeModal(!0), e(this).click(), !1
        }), e(document).on("click", ".site-control a[data-modal-nav-toggle]", function () {
            return e("body.modal-active").length ? (closeThemeModal(!0), setTimeout(function () {
                e("#page-menu .crumbs a:first").trigger("click")
            }, 305)) : (e(".nav-ctas__cta .lazyload--manual").removeClass("lazyload--manual").addClass("lazyload"), window.showInPageModal(e("#page-menu"))), !1
        }), e(document).on("focusin click", "input.select-on-focus", function () {
            e(this).select()
        }).on("mouseup", "input.select-on-focus", function (e) {
            e.preventDefault()
        }), e("#template textarea").each(function () {
            e(this).autogrow({
                animate: !1,
                onInitialize: !0
            })
        }), e(document).on("click", ".quantity-wrapper [data-quantity]", function () {
            var t = "up" == e(this).data("quantity") ? 1 : -1,
                a = e(this).closest(".quantity-wrapper").find("[name=quantity]");
            return a.val(Math.max(1, parseInt(a.val()) + t)), !1
        }), e(document).on("change", "select.redirecter", function () {
            window.location = e(this).val()
        }), theme.getUrlParameter = function (e) {
            var t = RegExp("[\\?&]" + (e = e.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]")) + "=([^&#]*)").exec(location.search);
            return null === t ? "" : decodeURIComponent(t[1].replace(/\+/g, " "))
        };
        var r = theme.getUrlParameter("form_type");

        function l(t) {
            9 === t.keyCode && (e("body").addClass("user-is-tabbing"), window.removeEventListener("keydown", l))
        }(theme.getUrlParameter("customer_posted") || r && "customer" === r) && window.location.hash && "footer_newsletter_signup" === window.location.hash && setTimeout(() => {
            e("html,body").animate({
                scrollTop: e("#footer_newsletter_signup").offset().top - 100
            }, 1e3)
        }, 100), navigator.userAgent.toLowerCase().indexOf("android") > -1 && e("html").addClass("os-android"), e(document).on("click", "[data-cc-checkout-button]", function (t) {
            if (e("#cc-checkout-form").length) return e("#cc-checkout-form").submit(), !1;
            console.warn("Unable to find form with id cc-checkout-form")
        }), e(document).on("click", "[data-cc-animate-click]", function (t) {
            if ((theme.settings.animationEnabledDesktop && theme.viewport.isSm() || theme.settings.animationEnabledMobile && theme.viewport.isXs()) && (window.location.hostname === this.hostname || !this.hostname.length) && e(this).attr("href").length > 0 && "#" !== e(this).attr("href")) {
                t.preventDefault();
                var a = e("body").hasClass("animation-speed-fast"),
                    o = a ? 100 : 200,
                    n = e("#cc-veil"),
                    s = n.hasClass("cc-veil--animate"),
                    r = e(this).attr("href");
                return e("body").append('<link rel="prefetch" href="'.concat(r, '">')), n.addClass("-in"), s && setTimeout(() => {
                    n.addClass("cc-veil--animate--in").addClass("cc-veil--animate--running")
                }, o + 100), setTimeout(() => {
                    n.removeClass("cc-veil--animate--in"), window.location.href = r
                }, s ? a ? 800 : 1300 : o), setTimeout(() => {
                    e("#cc-veil").removeClass("-in")
                }, 8e3), !1
            }
        }), setTimeout(lazySizes.autoSizer.checkElems, 1e3), window.addEventListener("keydown", l), document.querySelector(".shopify-challenge__container") && (document.getElementById("shopify-section-footer").style.display = "none"), theme.device.isTouch() && document.getElementsByTagName("html")[0].classList.add("touch");
        var c = document.body.querySelector(".template-index #page-content .shopify-section:first-child [data-cc-animate]");
        if (c && null === p.get("is_first_visit") && c.removeAttribute("data-cc-animate"), p.set("is_first_visit", "false"), e(document).on("shopify:section:reorder", function (e) {
                setTimeout(theme.init, 500)
            }), e(document).on("shopify:section:load", function (t) {
                e(".rte a img", t.target).closest("a").addClass("contains-img"), e(".feature-header", t.target).length && e(window).trigger("assessFeatureHeaders"), theme.inlineVideos.init(t.target), theme.init()
            }), e(document).on("shopify:section:unload", function (e) {
                theme.inlineVideos.destroy(e.target), setTimeout(() => {
                    theme.init()
                }, 0)
            }), e(window).on("debouncedresizewidth", theme.windowResize), window.matchMedia) {
            var d = window.matchMedia("(min-width: 768px)");
            d.addEventListener && d.addEventListener("change", e => {
                var t = new CustomEvent("cc-mobile-viewport-size-change");
                window.dispatchEvent(t)
            })
        }
        e(function () {
            theme.init(), e(window).trigger("slideshowfillheight"), e(window).trigger("assessFeatureHeaders")
        }), theme.Sections.init(), theme.Sections.register("header", theme.HeaderSection, {
            deferredLoad: !1
        }), theme.Sections.register("footer", theme.FooterSection, {
            deferredLoadViewportExcess: 1200
        }), theme.Sections.register("slideshow", theme.SlideshowSection, {
            deferredLoadViewportExcess: 1200
        }), theme.Sections.register("video", theme.VideoManager, {
            deferredLoadViewportExcess: 1200
        }), theme.Sections.register("background-video", theme.VideoManager, {
            deferredLoadViewportExcess: 1200
        }), theme.Sections.register("image-with-text-overlay", theme.ImageWithTextOverlay, {
            deferredLoadViewportExcess: 1200
        }), theme.Sections.register("image-beside-image", theme.ImageBesideImageSection, {
            deferredLoadViewportExcess: 1200
        }), theme.Sections.register("featured-collection", theme.FeaturedCollectionSection, {
            deferredLoadViewportExcess: 1200
        }), theme.Sections.register("collection-list", theme.CollectionListSection, {
            deferredLoadViewportExcess: 1200
        }), theme.Sections.register("featured-blog", theme.FeaturedBlogSection, {
            deferredLoadViewportExcess: 1200
        }), theme.Sections.register("product-template", theme.ProductTemplateSection, {
            deferredLoadViewportExcess: 200
        }), theme.Sections.register("collection-template", theme.FilterManager, {
            deferredLoad: !1
        }), theme.Sections.register("blog-template", theme.BlogTemplateSection, {
            deferredLoad: !1
        }), theme.Sections.register("article-template", theme.ArticleTemplateSection, {
            deferredLoad: !1
        }), theme.Sections.register("list-collections", theme.ListCollectionsSection, {
            deferredLoadViewportExcess: 1200
        }), theme.Sections.register("cart-template", theme.CartTemplateSection, {
            deferredLoad: !1
        }), theme.Sections.register("product-recommendations", theme.ProductRecommendations, {
            deferredLoadViewportExcess: 1200
        }), theme.Sections.register("gallery", theme.GallerySection, {
            deferredLoadViewportExcess: 1200
        }), theme.Sections.register("testimonials", theme.TestimonialsSection, {
            deferredLoadViewportExcess: 1200
        }), theme.Sections.register("accordion", theme.AccordionSection, {
            deferredLoadViewportExcess: 1200
        }), theme.Sections.register("faq", theme.FaqSection, {
            deferredLoadViewportExcess: 1200
        }), theme.Sections.register("search-template", theme.FilterManager, {
            deferredLoad: !1
        }), theme.Sections.register("scrolling-text", theme.ScrollingTextSection, {
            deferredLoadViewportExcess: 1200
        })
    }), e(function (e) {
        r.sections.length ? r.sections.forEach(e => {
            try {
                var t = {};
                void 0 !== e.deferredLoad && (t.deferredLoad = e.deferredLoad), void 0 !== e.deferredLoadViewportExcess && (t.deferredLoadViewportExcess = e.deferredLoadViewportExcess), theme.Sections.register(e.name, e.section, t)
            } catch (a) {
                console.error("Unable to register section ".concat(e.name, "."), a)
            }
        }) : console.warn("Barry: No common sections have been registered.")
    })
}(theme.jQuery);

(function () {
  function fixCartTaxDisplay() {
    const wrappers = document.querySelectorAll('.cd-cart-item-prices');
    wrappers.forEach(wrapper => {
      wrapper.querySelectorAll('.tax-price-helper').forEach(el => {
        el.style.display = 'none';
      });
      const comparePrice = wrapper.querySelector('.cd-cart-item-compare-price');
      if (comparePrice && comparePrice.nextElementSibling?.classList.contains('tax-price-helper')) {
        comparePrice.nextElementSibling.style.display = '';
      }
      const finalPrice = wrapper.querySelector('.cd-cart-item-price.has-discount');
      if (finalPrice && finalPrice.nextElementSibling?.classList.contains('tax-price-helper')) {
        finalPrice.nextElementSibling.style.display = '';
      }
    });
  }
  document.addEventListener('DOMContentLoaded', fixCartTaxDisplay);
  const observer = new MutationObserver(fixCartTaxDisplay);
  observer.observe(document.body, { childList: true, subtree: true });
})();